/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./assets/component.js":
/*!*****************************!*\
  !*** ./assets/component.js ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Component: () => (/* binding */ Component)
/* harmony export */ });
/* harmony import */ var _theme_critical__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @theme/critical */ "./assets/critical.js");
/* harmony import */ var _theme_utilities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @theme/utilities */ "./assets/utilities.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }



/**
 * @typedef {Record<string, Element | Element[] | undefined>} Refs
 */

/**
 * @template {Refs} T
 * @typedef {T & Refs} RefsType
 */

/**
 * Base class that powers our custom web components.
 *
 * Manages references to child elements with `ref` attributes and sets up mutation observers to keep
 * the refs updated when the DOM changes. Also handles declarative event listeners using.
 *
 * @template {Refs} [T=Refs]
 * @extends {DeclarativeShadowElement}
 */
var _Component_brand = /*#__PURE__*/new WeakSet();
var _mutationObserver = /*#__PURE__*/new WeakMap();
var _isDescendant = /*#__PURE__*/new WeakMap();
var Component = /*#__PURE__*/function (_DeclarativeShadowEle) {
  function Component() {
    var _this;
    _classCallCheck(this, Component);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Component, [].concat(args));
    /**
     * Updates the `refs` object by querying all descendant elements with `ref` attributes and storing references to them.
     *
     * This method is called to keep the `refs` object in sync with the DOM.
     */
    _classPrivateMethodInitSpec(_this, _Component_brand);
    /**
     * An object holding references to child elements with `ref` attributes.
     *
     * @type {RefsType<T>}
     */
    _defineProperty(_this, "refs", /** @type {RefsType<T>} */{});
    /**
     * An array of required refs. If a ref is not found, an error will be thrown.
     *
     * @type {string[] | undefined}
     */
    _defineProperty(_this, "requiredRefs", void 0);
    /**
     * MutationObserver instance to observe changes in the component's DOM subtree and update refs accordingly.
     *
     * @type {MutationObserver}
     */
    _classPrivateFieldInitSpec(_this, _mutationObserver, new MutationObserver(function (mutations) {
      if (mutations.some(function (m) {
        return m.type === 'attributes' && _classPrivateFieldGet(_isDescendant, _this).call(_this, m.target) || m.type === 'childList' && [].concat(_toConsumableArray(m.addedNodes), _toConsumableArray(m.removedNodes)).some(_classPrivateFieldGet(_isDescendant, _this));
      })) {
        _assertClassBrand(_Component_brand, _this, _updateRefs).call(_this);
      }
    }));
    /**
     * Checks if a given node is a descendant of this component.
     *
     * @param {Node} node - The node to check.
     * @returns {boolean} True if the node is a descendant of this component.
     */
    _classPrivateFieldInitSpec(_this, _isDescendant, function (node) {
      return getClosestComponent(getAncestor(node)) === _this;
    });
    return _this;
  }
  _inherits(Component, _DeclarativeShadowEle);
  return _createClass(Component, [{
    key: "roots",
    get:
    /**
     * Gets the root node of the component, which is either its shadow root or the component itself.
     *
     * @returns {(ShadowRoot | Component<T>)[]} The root nodes.
     */
    function get() {
      return this.shadowRoot ? [this, this.shadowRoot] : [this];
    }

    /**
     * Called when the element is connected to the document's DOM.
     *
     * Initializes event listeners and refs.
     */
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      _superPropGet(Component, "connectedCallback", this, 3)([]);
      registerEventListeners();
      _assertClassBrand(_Component_brand, this, _updateRefs).call(this);
      (0,_theme_utilities__WEBPACK_IMPORTED_MODULE_1__.requestIdleCallback)(function () {
        var _iterator = _createForOfIteratorHelper(_this2.roots),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var root = _step.value;
            _classPrivateFieldGet(_mutationObserver, _this2).observe(root, {
              childList: true,
              subtree: true,
              attributes: true,
              attributeFilter: ['ref'],
              attributeOldValue: true
            });
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    }

    /**
     * Called when the element is re-rendered by the Section Rendering API.
     */
  }, {
    key: "updatedCallback",
    value: function updatedCallback() {
      _classPrivateFieldGet(_mutationObserver, this).takeRecords();
      _assertClassBrand(_Component_brand, this, _updateRefs).call(this);
    }

    /**
     * Called when the element is disconnected from the document's DOM.
     *
     * Disconnects the mutation observer.
     */
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      _classPrivateFieldGet(_mutationObserver, this).disconnect();
    }
  }]);
}(_theme_critical__WEBPACK_IMPORTED_MODULE_0__.DeclarativeShadowElement);

/**
 * Get the ancestor of a given node.
 *
 * @param {Node} node - The node to get the ancestor of.
 * @returns {Node | null} The ancestor of the node or null if none is found.
 */
function _updateRefs() {
  var _this3 = this,
    _this$requiredRefs;
  var refs = /** @type any */{};
  var elements = this.roots.reduce(function (acc, root) {
    var _iterator2 = _createForOfIteratorHelper(root.querySelectorAll('[ref]')),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var element = _step2.value;
        if (!_classPrivateFieldGet(_isDescendant, _this3).call(_this3, element)) continue;
        acc.add(element);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return acc;
  }, /** @type {Set<Element>} */new Set());
  var _iterator3 = _createForOfIteratorHelper(elements),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _ref3$getAttribute;
      var _ref3 = _step3.value;
      var refName = (_ref3$getAttribute = _ref3.getAttribute('ref')) !== null && _ref3$getAttribute !== void 0 ? _ref3$getAttribute : '';
      var isArray = refName.endsWith('[]');
      var path = isArray ? refName.slice(0, -2) : refName;
      if (isArray) {
        var array = Array.isArray(refs[path]) ? refs[path] : [];
        array.push(_ref3);
        refs[path] = array;
      } else {
        refs[path] = _ref3;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  if ((_this$requiredRefs = this.requiredRefs) !== null && _this$requiredRefs !== void 0 && _this$requiredRefs.length) {
    var _iterator4 = _createForOfIteratorHelper(this.requiredRefs),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var ref = _step4.value;
        if (!(ref in refs)) {
          throw new MissingRefError(ref, this);
        }
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }
  this.refs = /** @type {RefsType<T>} */refs;
}
function getAncestor(node) {
  if (node.parentNode) return node.parentNode;
  var root = node.getRootNode();
  if (root instanceof ShadowRoot) return root.host;
  return null;
}

/**
 * Recursively finds the closest ancestor that is an instance of `Component`.
 *
 * @param {Node | null} node - The starting node to search from.
 * @returns {HTMLElement | null} The closest ancestor `Component` instance or null if none is found.
 */
function getClosestComponent(node) {
  if (!node) return null;
  if (node instanceof Component) return node;
  if (node instanceof HTMLElement && node.tagName.toLowerCase().endsWith('-component')) return node;
  var ancestor = getAncestor(node);
  if (ancestor) return getClosestComponent(ancestor);
  return null;
}

/**
 * Initializes the event listeners for custom event handling.
 *
 * Sets up event listeners for specified events and delegates the handling of those events
 * to methods defined on the closest `Component` instance, based on custom attributes.
 */
var initialized = false;
function registerEventListeners() {
  if (initialized) return;
  initialized = true;
  var events = ['click', 'change', 'select', 'focus', 'blur', 'submit', 'input', 'keydown', 'keyup', 'toggle'];
  var shouldBubble = ['focus', 'blur'];
  var expensiveEvents = ['pointerenter', 'pointerleave'];
  var _loop = function _loop() {
    var eventName = _arr[_i];
    var attribute = "on:".concat(eventName);
    document.addEventListener(eventName, function (event) {
      var _element$getAttribute;
      var element = getElement(event);
      if (!element) return;
      var proxiedEvent = event.target !== element ? new Proxy(event, {
        get: function get(target, property) {
          if (property === 'target') return element;
          var value = Reflect.get(target, property);
          if (typeof value === 'function') {
            return value.bind(target);
          }
          return value;
        }
      }) : event;
      var value = (_element$getAttribute = element.getAttribute(attribute)) !== null && _element$getAttribute !== void 0 ? _element$getAttribute : '';
      var _value$split = value.split('/'),
        _value$split2 = _slicedToArray(_value$split, 2),
        selector = _value$split2[0],
        method = _value$split2[1];
      // Extract the last segment of the attribute value delimited by `?` or `/`
      // Do not use lookback for Safari 16.0 compatibility
      var matches = value.match(/([\/\?][^\/\?]+)([\/\?][^\/\?]+)$/);
      var data = matches ? matches[2] : null;
      var instance = selector ? selector.startsWith('#') ? document.querySelector(selector) : element.closest(selector) : getClosestComponent(element);
      if (!(instance instanceof Component) || !method) return;
      method = method.replace(/\?.*/, '');
      var callback = /** @type {any} */instance[method];
      if (typeof callback === 'function') {
        try {
          /** @type {(Event | Data)[]} */
          var args = [proxiedEvent];
          if (data) args.unshift(parseData(data));
          callback.call.apply(callback, [instance].concat(args));
        } catch (error) {
          console.error(error);
        }
      }
    }, {
      capture: true
    });
  };
  for (var _i = 0, _arr = [].concat(events, expensiveEvents); _i < _arr.length; _i++) {
    _loop();
  }

  /** @param {Event} event */
  function getElement(event) {
    var _event$composedPath$, _event$composedPath;
    var target = (_event$composedPath$ = (_event$composedPath = event.composedPath) === null || _event$composedPath === void 0 ? void 0 : _event$composedPath.call(event)[0]) !== null && _event$composedPath$ !== void 0 ? _event$composedPath$ : event.target;
    if (!(target instanceof Element)) return;
    if (target.hasAttribute("on:".concat(event.type))) {
      return target;
    }
    if (expensiveEvents.includes(event.type)) {
      return null;
    }
    return event.bubbles || shouldBubble.includes(event.type) ? target.closest("[on\\:".concat(event.type, "]")) : null;
  }
}

/**
 * Parses a string to extract data based on a delimiter.
 *
 * @param {string} str - The string to parse.
 * @returns {Object|Array<string|number>|string} The parsed data.
 */
function parseData(str) {
  var delimiter = str[0];
  var data = str.slice(1);
  return delimiter === '?' ? Object.fromEntries(Array.from(new URLSearchParams(data).entries()).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return [key, parseValue(value)];
  })) : parseValue(data);
}

/**
 * @typedef {Object|Array<string|number>|string} Data
 */

/**
 * Parses a string value to its appropriate type.
 *
 * @param {string} str - The string to parse.
 * @returns {Data} The parsed value.
 */
function parseValue(str) {
  if (str === 'true') return true;
  if (str === 'false') return false;
  var maybeNumber = Number(str);
  if (!isNaN(maybeNumber) && str.trim() !== '') return maybeNumber;
  return str;
}

/**
 * Throws a formatted error when a required ref is not found in the component.
 */
var MissingRefError = /*#__PURE__*/function (_Error) {
  /**
   * @param {string} ref
   * @param {Component} component
   */
  function MissingRefError(ref, component) {
    _classCallCheck(this, MissingRefError);
    return _callSuper(this, MissingRefError, ["Required ref \"".concat(ref, "\" not found in component ").concat(component.tagName.toLowerCase())]);
  }
  _inherits(MissingRefError, _Error);
  return _createClass(MissingRefError);
}(/*#__PURE__*/_wrapNativeSuper(Error));

/***/ }),

/***/ "./assets/critical.js":
/*!****************************!*\
  !*** ./assets/critical.js ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DeclarativeShadowElement: () => (/* binding */ DeclarativeShadowElement),
/* harmony export */   OverflowList: () => (/* binding */ OverflowList),
/* harmony export */   OverflowMinimumEvent: () => (/* binding */ OverflowMinimumEvent),
/* harmony export */   ReflowEvent: () => (/* binding */ ReflowEvent),
/* harmony export */   ResizeNotifier: () => (/* binding */ ResizeNotifier),
/* harmony export */   calculateHeaderGroupHeight: () => (/* binding */ calculateHeaderGroupHeight)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
/*
 * Declarative shadow DOM is only initialized on the initial render of the page.
 * If the component is mounted after the browser finishes the initial render,
 * the shadow root needs to be manually hydrated.
 */
var DeclarativeShadowElement = /*#__PURE__*/function (_HTMLElement) {
  function DeclarativeShadowElement() {
    _classCallCheck(this, DeclarativeShadowElement);
    return _callSuper(this, DeclarativeShadowElement, arguments);
  }
  _inherits(DeclarativeShadowElement, _HTMLElement);
  return _createClass(DeclarativeShadowElement, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      if (!this.shadowRoot) {
        var template = this.querySelector(':scope > template[shadowrootmode="open"]');
        if (!(template instanceof HTMLTemplateElement)) return;
        var shadow = this.attachShadow({
          mode: 'open'
        });
        shadow.append(template.content.cloneNode(true));
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));

/**
 * A custom ResizeObserver that only calls the callback when the element is resized.
 * By default the ResizeObserver callback is called when the element is first observed.
 */
var _initialized = /*#__PURE__*/new WeakMap();
var ResizeNotifier = /*#__PURE__*/function (_ResizeObserver) {
  /**
   * @param {ResizeObserverCallback} callback
   */
  function ResizeNotifier(callback) {
    var _this;
    _classCallCheck(this, ResizeNotifier);
    _this = _callSuper(this, ResizeNotifier, [function (entries) {
      if (_classPrivateFieldGet(_initialized, _assertThisInitialized(_this))) return callback(entries, _assertThisInitialized(_this));
      _classPrivateFieldSet(_initialized, _assertThisInitialized(_this), true);
    }]);
    _classPrivateFieldInitSpec(_this, _initialized, false);
    return _this;
  }
  _inherits(ResizeNotifier, _ResizeObserver);
  return _createClass(ResizeNotifier, [{
    key: "disconnect",
    value: function disconnect() {
      _classPrivateFieldSet(_initialized, this, false);
      _superPropGet(ResizeNotifier, "disconnect", this, 3)([]);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(ResizeObserver));

/**
 * Event class for overflow minimum items updates
 * @extends {Event}
 */
var OverflowMinimumEvent = /*#__PURE__*/function (_Event) {
  /**
   * Creates a new OverflowMinimumEvent
   * @param {boolean} minimumReached - Whether the minimum number of visible items has been reached
   */
  function OverflowMinimumEvent(minimumReached) {
    var _this2;
    _classCallCheck(this, OverflowMinimumEvent);
    _this2 = _callSuper(this, OverflowMinimumEvent, ['overflowMinimum', {
      bubbles: true
    }]);
    _this2.detail = {
      minimumReached: minimumReached
    };
    return _this2;
  }
  _inherits(OverflowMinimumEvent, _Event);
  return _createClass(OverflowMinimumEvent);
}(/*#__PURE__*/_wrapNativeSuper(Event));
var ReflowEvent = /*#__PURE__*/function (_Event2) {
  /**
   * @param {HTMLElement} lastVisibleElement - The element to move to the last visible position
   */
  function ReflowEvent(lastVisibleElement) {
    var _this3;
    _classCallCheck(this, ReflowEvent);
    _this3 = _callSuper(this, ReflowEvent, ['reflow', {
      bubbles: true
    }]);
    _this3.detail = {
      lastVisibleElement: lastVisibleElement
    };
    return _this3;
  }
  _inherits(ReflowEvent, _Event2);
  return _createClass(ReflowEvent);
}(/*#__PURE__*/_wrapNativeSuper(Event));

/**
 * A custom element that wraps a list of items and moves them to an overflow slot when they don't fit.
 * This component is used in the header section, it needs to be render-blocking to avoid layout shifts.
 * @attr {string | null} minimum-items When set, the element enters a 'minimum-reached' state when visible items are at or below this number.
 * @example
 * <overflow-list minimum-items="2">
 *   <!-- list items -->
 * </overflow-list>
 */
var _OverflowList_brand = /*#__PURE__*/new WeakSet();
var _scheduled = /*#__PURE__*/new WeakMap();
var _lastDimensions = /*#__PURE__*/new WeakMap();
var _handleChange = /*#__PURE__*/new WeakMap();
var _reflowItems = /*#__PURE__*/new WeakMap();
var _refs = /*#__PURE__*/new WeakMap();
var _resizeObserver = /*#__PURE__*/new WeakMap();
var _mutationObserver = /*#__PURE__*/new WeakMap();
var OverflowList = /*#__PURE__*/function (_DeclarativeShadowEle) {
  function OverflowList() {
    var _this4;
    _classCallCheck(this, OverflowList);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this4 = _callSuper(this, OverflowList, [].concat(args));
    /**
     * Initialize the element
     */
    _classPrivateMethodInitSpec(_this4, _OverflowList_brand);
    _classPrivateFieldInitSpec(_this4, _scheduled, false);
    /**
     * @type {{width: number | null, height: number | null}}
     */
    _classPrivateFieldInitSpec(_this4, _lastDimensions, {
      width: null,
      height: null
    });
    /**
     * @type {ResizeObserverCallback & MutationCallback}
     */
    _classPrivateFieldInitSpec(_this4, _handleChange, function (event) {
      if (_classPrivateFieldGet(_scheduled, _this4)) return;
      var width = null;
      var height = null;
      var isResize = false;
      var _iterator = _createForOfIteratorHelper(event.entries()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
            entry = _step$value[1];
          if (!(entry instanceof ResizeObserverEntry)) break;
          // There should only be one entry
          isResize = true;
          width = Math.round(entry.contentRect.width);
          height = Math.round(entry.contentRect.height);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (isResize) {
        if (!width || !height || width === _classPrivateFieldGet(_lastDimensions, _this4).width && height === _classPrivateFieldGet(_lastDimensions, _this4).height) {
          // Skip reflow if dimensions are 0 or the same as the last reflow
          return;
        }
        _classPrivateFieldSet(_lastDimensions, _this4, {
          width: Math.round(width),
          height: Math.round(height)
        });
      }
      _classPrivateFieldSet(_scheduled, _this4, true);
      _this4.schedule(function () {
        _classPrivateFieldGet(_reflowItems, _this4).call(_this4);
        _classPrivateFieldSet(_scheduled, _this4, false);
      });
    });
    /**
     * Reflow items based on available space within the list.
     * @param {HTMLElement} [lastVisibleElement] Optional element to place in last visible position
     */
    _classPrivateFieldInitSpec(_this4, _reflowItems, function (lastVisibleElement) {
      var _this4$firstElementCh, _this4$firstElementCh2;
      var _classPrivateFieldGet2 = _classPrivateFieldGet(_refs, _this4),
        defaultSlot = _classPrivateFieldGet2.defaultSlot,
        overflowSlot = _classPrivateFieldGet2.overflowSlot,
        moreSlot = _classPrivateFieldGet2.moreSlot,
        list = _classPrivateFieldGet2.list,
        placeholder = _classPrivateFieldGet2.placeholder;
      _classPrivateFieldGet(_resizeObserver, _this4).disconnect();
      _classPrivateFieldGet(_mutationObserver, _this4).disconnect();

      // Avoid layout shifts while reflowing the list
      var _ref = (_this4$firstElementCh = (_this4$firstElementCh2 = _this4.firstElementChild) === null || _this4$firstElementCh2 === void 0 ? void 0 : _this4$firstElementCh2.getBoundingClientRect()) !== null && _this4$firstElementCh !== void 0 ? _this4$firstElementCh : {},
        height = _ref.height;
      if (height) list.style.height = "".concat(height, "px");
      list.style.setProperty('overflow', 'hidden');

      // Move all elements to the default slot so we can check which ones overflow
      _assertClassBrand(_OverflowList_brand, _this4, _moveItemsToDefaultSlot).call(_this4);
      var elements = defaultSlot.assignedElements();

      // Make sure the "More" item and placeholder are hidden
      moreSlot.hidden = true;
      placeholder.hidden = true;

      // First, check if all the items fit
      var rootRect = list.getBoundingClientRect();

      // Store the initial dimensions for comparison later
      _classPrivateFieldSet(_lastDimensions, _this4, {
        width: Math.round(rootRect.width),
        height: Math.round(rootRect.height)
      });
      var getVisibleElements = function getVisibleElements() {
        return elements.filter(function (el) {
          return el.getBoundingClientRect().top <= rootRect.top;
        });
      };
      var visibleElements = getVisibleElements();

      // If not all items fit or we have a lastVisibleElement, let's calculate with "More" button
      if (visibleElements.length !== elements.length || lastVisibleElement) {
        // Putting the "More" item (and lastVisibleElement, if provided) at the start of the list lets us see which items will fit on the same row
        moreSlot.style.setProperty('order', '-1');
        moreSlot.hidden = false;
        moreSlot.style.setProperty('height', "".concat(height, "px"));
        if (lastVisibleElement) {
          lastVisibleElement.style.setProperty('order', '-1');
        }

        // Recalculate the visible elements
        visibleElements = getVisibleElements();

        // Reset the order
        moreSlot.style.removeProperty('order');
        if (lastVisibleElement) {
          lastVisibleElement.style.removeProperty('order');
        }

        // If we have a lastVisibleElement, ensure it's in the last visible position
        if (lastVisibleElement) {
          var visibleIndex = visibleElements.indexOf(lastVisibleElement);
          if (visibleIndex !== -1) {
            // Remove lastVisibleElement from its current position
            visibleElements.splice(visibleIndex, 1);
            // Add it to the end of visible elements
            visibleElements.push(lastVisibleElement);
          }
        }
        moreSlot.style.setProperty('height', 'auto');
      }
      var overflowingElements = elements.filter(function (element) {
        return !visibleElements.includes(element);
      });
      var _overflowingElements = _slicedToArray(overflowingElements, 1),
        firstOverflowingElement = _overflowingElements[0];
      var hasOverflow = overflowingElements.length > 0;
      var placeholderWidth = firstOverflowingElement ? firstOverflowingElement.clientWidth : 0;

      // Move the elements to the correct slot
      var _iterator2 = _createForOfIteratorHelper(elements),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var element = _step2.value;
          element.slot = overflowingElements.includes(element) ? overflowSlot.name : defaultSlot.name;
        }

        // If there are overflowing elements
        // Show more button and placeholder if needed
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      moreSlot.hidden = !hasOverflow;
      if (hasOverflow) {
        // Set the width and height of the placeholder so the list can grow if there is space
        placeholder.style.width = "".concat(placeholderWidth, "px");
        placeholder.hidden = false;
      }
      list.style.setProperty('counter-reset', "overflow-count ".concat(overflowingElements.length));
      _this4.style.setProperty('--overflow-count', "".concat(overflowingElements.length));
      list.style.removeProperty('overflow');

      // Check if the minimum-reached state should be updated
      hasOverflow && _assertClassBrand(_OverflowList_brand, _this4, _updateMinimumReached).call(_this4, visibleElements);

      // Observe the list for changes in size
      _classPrivateFieldGet(_resizeObserver, _this4).observe(_this4);
      _classPrivateFieldGet(_mutationObserver, _this4).observe(_this4, {
        childList: true
      });
    });
    /**
     * @type {{
     *   defaultSlot: HTMLSlotElement;
     *   overflowSlot: HTMLSlotElement;
     *   moreSlot: HTMLSlotElement;
     *   overflow: HTMLElement;
     *   list: HTMLUListElement;
     *   placeholder: HTMLLIElement;
     * }}
     */
    _classPrivateFieldInitSpec(_this4, _refs, void 0);
    /**
     * @type {ResizeObserver}
     */
    _classPrivateFieldInitSpec(_this4, _resizeObserver, new ResizeNotifier(_classPrivateFieldGet(_handleChange, _this4)));
    /**
     * @type {MutationObserver}
     */
    _classPrivateFieldInitSpec(_this4, _mutationObserver, new MutationObserver(_classPrivateFieldGet(_handleChange, _this4)));
    return _this4;
  }
  _inherits(OverflowList, _DeclarativeShadowEle);
  return _createClass(OverflowList, [{
    key: "attributeChangedCallback",
    value:
    /**
     * @param {string} name
     * @param {string} oldValue
     * @param {string} newValue
     */
    function attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'disabled') {
        if (newValue === 'true') {
          _assertClassBrand(_OverflowList_brand, this, _reset).call(this);
        } else {
          _classPrivateFieldGet(_reflowItems, this).call(this);
        }
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this5 = this;
      _superPropGet(OverflowList, "connectedCallback", this, 3)([]);
      if (this.hasAttribute('defer')) {
        var deferredReflow = function deferredReflow() {
          // Remove attribute first to change layout before calculating the actual size
          _this5.removeAttribute('defer');
          _assertClassBrand(_OverflowList_brand, _this5, _initialize).call(_this5);
        };
        var schedule = this.schedule;
        var requestIdleCallback = typeof window.requestIdleCallback === 'function' ? window.requestIdleCallback : setTimeout;
        requestIdleCallback(function () {
          return schedule(deferredReflow);
        });
      } else if (this.shadowRoot) {
        _assertClassBrand(_OverflowList_brand, this, _initialize).call(this);
      } else {
        // Not all element children has been parsed yet, try again in the next tick
        // <overflow-list> is a special case as critical.js can execute before DOMContentLoaded
        setTimeout(function () {
          _assertClassBrand(_OverflowList_brand, _this5, _initialize).call(_this5);
        }, 0);
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      _classPrivateFieldGet(_resizeObserver, this).disconnect();
    }
  }, {
    key: "schedule",
    get: function get() {
      var _Theme;
      return typeof ((_Theme = Theme) === null || _Theme === void 0 || (_Theme = _Theme.utilities) === null || _Theme === void 0 || (_Theme = _Theme.scheduler) === null || _Theme === void 0 ? void 0 : _Theme.schedule) === 'function' ? Theme.utilities.scheduler.schedule : /** @param {FrameRequestCallback} callback */function (callback) {
        return requestAnimationFrame(function () {
          return setTimeout(callback, 0);
        });
      };
    }
  }, {
    key: "minimumItems",
    get:
    /**
     * Get the minimum number of items before changing the minimum-reached state
     * @returns {number | null}
     */
    function get() {
      var value = this.getAttribute('minimum-items');
      return value ? parseInt(value, 10) : null;
    }
  }, {
    key: "overflowSlot",
    get: function get() {
      var _classPrivateFieldGet3 = _classPrivateFieldGet(_refs, this),
        overflowSlot = _classPrivateFieldGet3.overflowSlot;
      return overflowSlot;
    }
  }, {
    key: "defaultSlot",
    get: function get() {
      var _classPrivateFieldGet4 = _classPrivateFieldGet(_refs, this),
        defaultSlot = _classPrivateFieldGet4.defaultSlot;
      return defaultSlot;
    }
  }, {
    key: "showAll",
    value:
    /**
     * Show all items in the list.
     */
    function showAll() {
      var _classPrivateFieldGet5 = _classPrivateFieldGet(_refs, this),
        placeholder = _classPrivateFieldGet5.placeholder;
      placeholder.style.setProperty('width', '0');
      placeholder.style.setProperty('display', 'none');
      this.setAttribute('disabled', 'true');
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ['disabled', 'minimum-items'];
    }
  }]);
}(DeclarativeShadowElement);
function _initialize() {
  var _this6 = this;
  var shadowRoot = this.shadowRoot;
  if (!shadowRoot) throw new Error('Missing shadow root');
  var defaultSlot = shadowRoot.querySelector('slot:not([name])');
  var overflowSlot = shadowRoot.querySelector('slot[name="overflow"]');
  var moreSlot = shadowRoot.querySelector('slot[name="more"]');
  var overflow = shadowRoot.querySelector('[part="overflow"]');
  var list = shadowRoot.querySelector('[part="list"]');
  var placeholder = shadowRoot.querySelector('[part="placeholder"]');
  if (!(defaultSlot instanceof HTMLSlotElement) || !(overflowSlot instanceof HTMLSlotElement) || !(moreSlot instanceof HTMLSlotElement) || !(overflow instanceof HTMLElement) || !(list instanceof HTMLUListElement) || !(placeholder instanceof HTMLLIElement)) {
    throw new Error('Invalid element types in <OverflowList />');
  }
  _classPrivateFieldSet(_refs, this, {
    defaultSlot: defaultSlot,
    overflowSlot: overflowSlot,
    moreSlot: moreSlot,
    overflow: overflow,
    list: list,
    placeholder: placeholder
  });

  // Add event listener for reflow requests
  this.addEventListener('reflow', /** @param {ReflowEvent} event */function (event) {
    _classPrivateFieldGet(_reflowItems, _this6).call(_this6, event.detail.lastVisibleElement);
  });
  _classPrivateFieldGet(_reflowItems, this).call(this);
}
/**
 * Move all items to the default slot.
 */
function _moveItemsToDefaultSlot() {
  var _classPrivateFieldGet6 = _classPrivateFieldGet(_refs, this),
    defaultSlot = _classPrivateFieldGet6.defaultSlot,
    overflowSlot = _classPrivateFieldGet6.overflowSlot;
  var _iterator3 = _createForOfIteratorHelper(overflowSlot.assignedElements()),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var element = _step3.value;
      element.slot = defaultSlot.name;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
}
/**
 * Reset the list to its initial state and disconnect the observers.
 */
function _reset() {
  var _classPrivateFieldGet7 = _classPrivateFieldGet(_refs, this),
    list = _classPrivateFieldGet7.list;
  _classPrivateFieldGet(_mutationObserver, this).disconnect();
  _classPrivateFieldGet(_resizeObserver, this).disconnect();
  _assertClassBrand(_OverflowList_brand, this, _moveItemsToDefaultSlot).call(this);
  list.style.removeProperty('height');
  this.style.setProperty('--overflow-count', '0');
}
/**
 * Sets the minimum-reached attribute and dispatches a custom event based on visible elements count
 * @param {Element[]} visibleElements - The currently visible elements
 */
function _updateMinimumReached(visibleElements) {
  if (this.minimumItems !== null) {
    var minimumReached = visibleElements.length < this.minimumItems;
    if (minimumReached) {
      this.setAttribute('minimum-reached', '');
    } else {
      this.removeAttribute('minimum-reached');
    }
    this.dispatchEvent(new OverflowMinimumEvent(minimumReached));
  }
}
if (!customElements.get('overflow-list')) {
  customElements.define('overflow-list', OverflowList);
}

// Function to calculate total height of header group children
function calculateHeaderGroupHeight() {
  var header = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.querySelector('#header-component');
  var headerGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.querySelector('#header-group');
  if (!headerGroup) return 0;
  var totalHeight = 0;
  var children = headerGroup.children;
  for (var i = 0; i < children.length; i++) {
    var element = children[i];
    if (element === header || !(element instanceof HTMLElement)) continue;
    totalHeight += element.offsetHeight;
  }
  return totalHeight;
}

/**
 * Initialize and maintain header height CSS variables.
 * This is critical for preventing layout shifts during page load.
 * There is a `ResizeObserver` and `MutationObserver` that kicks in post hydration in header.js
 * Note: header-group uses display: contents, so we must observe all children.
 */
(function () {
  var header = document.querySelector('header-component');

  // Early exit if no header - nothing to do
  if (!(header instanceof HTMLElement)) return;

  // Calculate initial height(s
  var headerHeight = header.offsetHeight;
  var headerGroupHeight = calculateHeaderGroupHeight(header);
  document.body.style.setProperty('--header-height', "".concat(headerHeight, "px"));
  document.body.style.setProperty('--header-group-height', "".concat(headerGroupHeight, "px"));
})();

/**
 * Updates CSS custom properties for transparent header offset calculation
 * Avoids expensive :has() selectors
 */
(function (_hasHeaderSection$nex) {
  var header = document.querySelector('#header-component');
  var headerGroup = document.querySelector('#header-group');
  var hasHeaderSection = headerGroup === null || headerGroup === void 0 ? void 0 : headerGroup.querySelector('.header-section');
  if (!hasHeaderSection || !(header !== null && header !== void 0 && header.hasAttribute('transparent'))) {
    document.body.style.setProperty('--transparent-header-offset-boolean', '0');
    return;
  }
  var hasImmediateSection = (_hasHeaderSection$nex = hasHeaderSection.nextElementSibling) === null || _hasHeaderSection$nex === void 0 ? void 0 : _hasHeaderSection$nex.classList.contains('shopify-section');
  var shouldApplyOffset = !hasImmediateSection ? '1' : '0';
  document.body.style.setProperty('--transparent-header-offset-boolean', shouldApplyOffset);
})();

/***/ }),

/***/ "./assets/events.js":
/*!**************************!*\
  !*** ./assets/events.js ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CartAddEvent: () => (/* binding */ CartAddEvent),
/* harmony export */   CartErrorEvent: () => (/* binding */ CartErrorEvent),
/* harmony export */   CartUpdateEvent: () => (/* binding */ CartUpdateEvent),
/* harmony export */   DiscountUpdateEvent: () => (/* binding */ DiscountUpdateEvent),
/* harmony export */   FilterUpdateEvent: () => (/* binding */ FilterUpdateEvent),
/* harmony export */   MediaStartedPlayingEvent: () => (/* binding */ MediaStartedPlayingEvent),
/* harmony export */   MegaMenuHoverEvent: () => (/* binding */ MegaMenuHoverEvent),
/* harmony export */   QuantitySelectorUpdateEvent: () => (/* binding */ QuantitySelectorUpdateEvent),
/* harmony export */   SlideshowSelectEvent: () => (/* binding */ SlideshowSelectEvent),
/* harmony export */   ThemeEvents: () => (/* binding */ ThemeEvents),
/* harmony export */   VariantSelectedEvent: () => (/* binding */ VariantSelectedEvent),
/* harmony export */   VariantUpdateEvent: () => (/* binding */ VariantUpdateEvent),
/* harmony export */   ZoomMediaSelectedEvent: () => (/* binding */ ZoomMediaSelectedEvent)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @namespace ThemeEvents
 * @description A collection of theme-specific events that can be used to trigger and listen for changes anywhere in the theme.
 * @example
 * document.dispatchEvent(new VariantUpdateEvent(variant, sectionId, { html }));
 * document.addEventListener(ThemeEvents.variantUpdate, (e) => { console.log(e.detail.variant) });
 */
var ThemeEvents = /*#__PURE__*/_createClass(function ThemeEvents() {
  _classCallCheck(this, ThemeEvents);
});

/**
 * Event fired when a variant is selected
 * @extends {Event}
 */
/** @static @constant {string} Event triggered when a variant is selected */
_defineProperty(ThemeEvents, "variantSelected", 'variant:selected');
/** @static @constant {string} Event triggered when a variant is changed */
_defineProperty(ThemeEvents, "variantUpdate", 'variant:update');
/** @static @constant {string} Event triggered when the cart items or quantities are updated */
_defineProperty(ThemeEvents, "cartUpdate", 'cart:update');
/** @static @constant {string} Event triggered when a cart update fails */
_defineProperty(ThemeEvents, "cartError", 'cart:error');
/** @static @constant {string} Event triggered when a media (video, 3d model) is loaded */
_defineProperty(ThemeEvents, "mediaStartedPlaying", 'media:started-playing');
// Event triggered when quantity-selector value is changed
_defineProperty(ThemeEvents, "quantitySelectorUpdate", 'quantity-selector:update');
/** @static @constant {string} Event triggered when a predictive search is expanded */
_defineProperty(ThemeEvents, "megaMenuHover", 'megaMenu:hover');
/** @static @constant {string} Event triggered when a zoom dialog media is selected */
_defineProperty(ThemeEvents, "zoomMediaSelected", 'zoom-media:selected');
/** @static @constant {string} Event triggered when a discount is applied */
_defineProperty(ThemeEvents, "discountUpdate", 'discount:update');
/** @static @constant {string} Event triggered when changing collection filters */
_defineProperty(ThemeEvents, "FilterUpdate", 'filter:update');
var VariantSelectedEvent = /*#__PURE__*/function (_Event) {
  /**
   * Creates a new VariantSelectedEvent
   * @param {Object} resource - The new variant object
   * @param {string} resource.id - The id of the variant
   */
  function VariantSelectedEvent(resource) {
    var _this;
    _classCallCheck(this, VariantSelectedEvent);
    _this = _callSuper(this, VariantSelectedEvent, [ThemeEvents.variantSelected, {
      bubbles: true
    }]);
    _this.detail = {
      resource: resource
    };
    return _this;
  }
  _inherits(VariantSelectedEvent, _Event);
  return _createClass(VariantSelectedEvent);
}(/*#__PURE__*/_wrapNativeSuper(Event));

/**
 * Event fired after a variant is updated
 * @extends {Event}
 */
var VariantUpdateEvent = /*#__PURE__*/function (_Event2) {
  /**
   * Creates a new VariantUpdateEvent
   * @param {Object} resource - The new variant object
   * @param {string} resource.id - The id of the variant
   * @param {boolean} resource.available - Whether the variant is available
   * @param {boolean} resource.inventory_management - Whether the variant has inventory management
   * @param {Object} [resource.featured_media] - The featured media of the variant
   * @param {string} [resource.featured_media.id] - The id of the featured media
   * @param {Object} [resource.featured_media.preview_image] - The preview image of the featured media
   * @param {string} [resource.featured_media.preview_image.src] - The src URL of the preview image
   * @param {string} sourceId - The id of the element the action was triggered from
   * @param {Object} data - Additional event data
   * @param {Document} data.html - The new document fragment for the variant
   * @param {string} data.productId - The product ID of the updated variant, used to ensure the correct product form is updated
   * @param {Object} [data.newProduct] - If a new product was loaded as part of the variant update (combined listing)
   * @param {string} data.newProduct.id - The id of the new product
   * @param {string} data.newProduct.url - The url of the new product
   */
  function VariantUpdateEvent(resource, sourceId, data) {
    var _this2;
    _classCallCheck(this, VariantUpdateEvent);
    _this2 = _callSuper(this, VariantUpdateEvent, [ThemeEvents.variantUpdate, {
      bubbles: true
    }]);
    _this2.detail = {
      resource: resource || null,
      sourceId: sourceId,
      data: {
        html: data.html,
        productId: data.productId,
        newProduct: data.newProduct
      }
    };
    return _this2;
  }
  _inherits(VariantUpdateEvent, _Event2);
  return _createClass(VariantUpdateEvent);
}(/*#__PURE__*/_wrapNativeSuper(Event));

/**
 * Event class for cart additions
 * @extends {Event}
 */
var CartAddEvent = /*#__PURE__*/function (_Event3) {
  /**
   * Creates a new CartAddEvent
   * @param {Object} [resource] - The new cart object
   * @param {string} [sourceId] - The id of the element the action was triggered from
   * @param {Object} [data] - Additional event data
   * @param {boolean} [data.didError] - Whether the cart operation failed
   * @param {string} [data.source] - The source of the cart update
   * @param {string} [data.productId] - The id of the product card that was updated
   * @param {number} [data.itemCount] - The number of items in the cart
   * @param {string} [data.variantId] - The id of the product variant that was added
   * @param {Record<string, string>} [data.sections] - The sections affected by the cart operation
   */
  function CartAddEvent(resource, sourceId, data) {
    var _this3;
    _classCallCheck(this, CartAddEvent);
    _this3 = _callSuper(this, CartAddEvent, [CartAddEvent.eventName, {
      bubbles: true
    }]);
    _this3.detail = {
      resource: resource,
      sourceId: sourceId,
      data: _objectSpread({}, data)
    };
    return _this3;
  }
  _inherits(CartAddEvent, _Event3);
  return _createClass(CartAddEvent);
}(/*#__PURE__*/_wrapNativeSuper(Event));

/**
 * Event class for cart updates
 * @extends {Event}
 */
_defineProperty(CartAddEvent, "eventName", ThemeEvents.cartUpdate);
var CartUpdateEvent = /*#__PURE__*/function (_Event4) {
  /**
   * Creates a new CartUpdateEvent
   * @param {Object} resource - The new cart object
   * @param {string} sourceId - The id of the element the action was triggered from
   * @param {Object} [data] - Additional event data
   * @param {boolean} [data.didError] - Whether the cart operation failed
   * @param {string} [data.source] - The source of the cart update
   * @param {string} [data.productId] - The id of the product card that was updated
   * @param {number} [data.itemCount] - The number of items in the cart
   * @param {string} [data.variantId] - The id of the product variant that was updated
   * @param {Record<string, string>} [data.sections] - The sections affected by the cart operation
   */
  function CartUpdateEvent(resource, sourceId, data) {
    var _this4;
    _classCallCheck(this, CartUpdateEvent);
    _this4 = _callSuper(this, CartUpdateEvent, [ThemeEvents.cartUpdate, {
      bubbles: true
    }]);
    _this4.detail = {
      resource: resource,
      sourceId: sourceId,
      data: _objectSpread({}, data)
    };
    return _this4;
  }
  _inherits(CartUpdateEvent, _Event4);
  return _createClass(CartUpdateEvent);
}(/*#__PURE__*/_wrapNativeSuper(Event));

/**
 * Event class for cart errors
 * @extends {Event}
 */
var CartErrorEvent = /*#__PURE__*/function (_Event5) {
  /**
   * Creates a new CartErrorEvent
   * @param {string} sourceId - The id of the element the action was triggered from
   * @param {string} message - A message from the server response
   * @param {Object} description - Description from the server response
   * @param {Object} errors - Errors from the server response
   */
  function CartErrorEvent(sourceId, message, description, errors) {
    var _this5;
    _classCallCheck(this, CartErrorEvent);
    _this5 = _callSuper(this, CartErrorEvent, [ThemeEvents.cartError, {
      bubbles: true
    }]);
    _this5.detail = {
      sourceId: sourceId,
      data: {
        message: message,
        errors: errors,
        description: description
      }
    };
    return _this5;
  }
  _inherits(CartErrorEvent, _Event5);
  return _createClass(CartErrorEvent);
}(/*#__PURE__*/_wrapNativeSuper(Event));

/**
 * Event class for quantity-selector updates
 * @extends {Event}
 */
var QuantitySelectorUpdateEvent = /*#__PURE__*/function (_Event6) {
  /**
   * Creates a new QuantitySelectorUpdateEvent
   * @param {number} quantity - Quantity value
   * @param {number} [cartLine] - The id of the updated cart line
   */
  function QuantitySelectorUpdateEvent(quantity, cartLine) {
    var _this6;
    _classCallCheck(this, QuantitySelectorUpdateEvent);
    _this6 = _callSuper(this, QuantitySelectorUpdateEvent, [ThemeEvents.quantitySelectorUpdate, {
      bubbles: true
    }]);
    _this6.detail = {
      quantity: quantity,
      cartLine: cartLine
    };
    return _this6;
  }
  _inherits(QuantitySelectorUpdateEvent, _Event6);
  return _createClass(QuantitySelectorUpdateEvent);
}(/*#__PURE__*/_wrapNativeSuper(Event));

/**
 * Event class for quantity-selector updates
 * @extends {Event}
 */
var DiscountUpdateEvent = /*#__PURE__*/function (_Event7) {
  /**
   * Creates a new DiscountUpdateEvent
   * @param {Object} resource - The new cart object
   * @param {string} sourceId - The id of the element the action was triggered from
   */
  function DiscountUpdateEvent(resource, sourceId) {
    var _this7;
    _classCallCheck(this, DiscountUpdateEvent);
    _this7 = _callSuper(this, DiscountUpdateEvent, [ThemeEvents.discountUpdate, {
      bubbles: true
    }]);
    _this7.detail = {
      resource: resource,
      sourceId: sourceId
    };
    return _this7;
  }
  _inherits(DiscountUpdateEvent, _Event7);
  return _createClass(DiscountUpdateEvent);
}(/*#__PURE__*/_wrapNativeSuper(Event));

/**
 * Event class for media playback starts
 * @extends {Event}
 */
var MediaStartedPlayingEvent = /*#__PURE__*/function (_Event8) {
  /**
   * Creates a new MediaStartedPlayingEvent
   * @param {HTMLElement} resource - The element containing the video that emitted the event
   */
  function MediaStartedPlayingEvent(resource) {
    var _this8;
    _classCallCheck(this, MediaStartedPlayingEvent);
    _this8 = _callSuper(this, MediaStartedPlayingEvent, [ThemeEvents.mediaStartedPlaying, {
      bubbles: true
    }]);
    _this8.detail = {
      resource: resource
    };
    return _this8;
  }
  _inherits(MediaStartedPlayingEvent, _Event8);
  return _createClass(MediaStartedPlayingEvent);
}(/*#__PURE__*/_wrapNativeSuper(Event));

/**
 * @typedef {Object} SlideshowSelectEventData
 * @property {number} index
 * @property {string | null} id
 * @property {Element} slide
 * @property {number} previousIndex
 * @property {boolean} userInitiated
 * @property {'select' | 'scroll' | 'drag'} trigger
 */

var SlideshowSelectEvent = /*#__PURE__*/function (_Event9) {
  /**  @param {SlideshowSelectEventData} data */
  function SlideshowSelectEvent(data) {
    var _this9;
    _classCallCheck(this, SlideshowSelectEvent);
    _this9 = _callSuper(this, SlideshowSelectEvent, [SlideshowSelectEvent.eventName, {
      bubbles: true
    }]);
    /** @type {SlideshowSelectEventData} */
    _defineProperty(_this9, "detail", void 0);
    _this9.detail = data;
    return _this9;
  }
  _inherits(SlideshowSelectEvent, _Event9);
  return _createClass(SlideshowSelectEvent);
}(/*#__PURE__*/_wrapNativeSuper(Event));

/**
 * Event class for zoom dialog media selection
 * @extends {Event}
 */
_defineProperty(SlideshowSelectEvent, "eventName", 'slideshow:select');
var ZoomMediaSelectedEvent = /*#__PURE__*/function (_Event0) {
  /**
   * Creates a new ZoomMediaSelectedEvent
   * @param {number} index - The index of the selected media
   */
  function ZoomMediaSelectedEvent(index) {
    var _this0;
    _classCallCheck(this, ZoomMediaSelectedEvent);
    _this0 = _callSuper(this, ZoomMediaSelectedEvent, [ThemeEvents.zoomMediaSelected, {
      bubbles: true
    }]);
    _this0.detail = {
      index: index
    };
    return _this0;
  }
  _inherits(ZoomMediaSelectedEvent, _Event0);
  return _createClass(ZoomMediaSelectedEvent);
}(/*#__PURE__*/_wrapNativeSuper(Event));

/**
 * Event class for mega menu hover being hovered over
 * @extends {Event}
 */
var MegaMenuHoverEvent = /*#__PURE__*/function (_Event1) {
  function MegaMenuHoverEvent() {
    _classCallCheck(this, MegaMenuHoverEvent);
    return _callSuper(this, MegaMenuHoverEvent, [ThemeEvents.megaMenuHover, {
      bubbles: true
    }]);
  }
  _inherits(MegaMenuHoverEvent, _Event1);
  return _createClass(MegaMenuHoverEvent);
}(/*#__PURE__*/_wrapNativeSuper(Event));

/** Event class for facet filtering updates */
var FilterUpdateEvent = /*#__PURE__*/function (_Event10) {
  /** @param {URLSearchParams} queryParams */
  function FilterUpdateEvent(queryParams) {
    var _this1;
    _classCallCheck(this, FilterUpdateEvent);
    _this1 = _callSuper(this, FilterUpdateEvent, [ThemeEvents.FilterUpdate, {
      bubbles: true
    }]);
    _this1.detail = {
      queryParams: queryParams
    };
    return _this1;
  }
  _inherits(FilterUpdateEvent, _Event10);
  return _createClass(FilterUpdateEvent, [{
    key: "shouldShowClearAll",
    value: function shouldShowClearAll() {
      return _toConsumableArray(this.detail.queryParams.entries()).filter(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
          key = _ref2[0];
        return key.startsWith('filter.');
      }).length > 0;
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(Event));

/***/ }),

/***/ "./assets/morph.js":
/*!*************************!*\
  !*** ./assets/morph.js ***!
  \*************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   morph: () => (/* binding */ morph)
/* harmony export */ });
/* harmony import */ var _theme_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @theme/component */ "./assets/component.js");


/**
 * @typedef {Object} Options
 * @property {boolean} [childrenOnly] - Only update children
 * @property {(node: Node | undefined) => string|number|undefined} [getNodeKey] - Get node key for matching
 * @property {(oldNode: Node, newNode: Node) => void} [onBeforeUpdate] - Pre-update hook
 * @property {(node: Node) => void} [onAfterUpdate] - Post-update hook
 * @property {(oldNode: Node, newNode: Node) => boolean} [reject] - Reject a node from being morphed
 */

/**
 * The options for the morph
 * @type {Options}
 */
var MORPH_OPTIONS = {
  childrenOnly: true,
  reject: function reject(oldNode, newNode) {
    var _newNode$nodeValue, _oldNode$parentElemen;
    if (newNode.nodeType === Node.TEXT_NODE && ((_newNode$nodeValue = newNode.nodeValue) === null || _newNode$nodeValue === void 0 ? void 0 : _newNode$nodeValue.trim()) === '') {
      return true;
    }
    if (newNode instanceof HTMLTemplateElement && newNode.shadowRootMode === 'open' && oldNode.parentElement && newNode.parentElement && oldNode.parentElement.tagName === newNode.parentElement.tagName && ((_oldNode$parentElemen = oldNode.parentElement) === null || _oldNode$parentElemen === void 0 ? void 0 : _oldNode$parentElemen.shadowRoot) != null) {
      // Ignore template elements of components that are already initialized
      return true;
    }
    if (newNode.nodeType === Node.COMMENT_NODE && newNode.nodeValue === 'shopify:rendered_by_section_api') {
      // Remove a comment node injected by the Section Rendering API in the Theme Editor
      return true;
    }
    return false;
  },
  onBeforeUpdate: function onBeforeUpdate(oldNode, newNode) {
    if (oldNode instanceof Element && newNode instanceof Element) {
      var attributes = ['product-grid-view'];
      for (var _i = 0, _attributes = attributes; _i < _attributes.length; _i++) {
        var attribute = _attributes[_i];
        var oldValue = oldNode.getAttribute(attribute);
        var newValue = newNode.getAttribute(attribute);
        if (oldValue && oldValue !== newValue) {
          newNode.setAttribute(attribute, oldValue);
        }
      }

      // Special case for elements that need to keep their style
      var elements = ['floating-panel-component'];
      for (var _i2 = 0, _elements = elements; _i2 < _elements.length; _i2++) {
        var element = _elements[_i2];
        var tagName = element.toUpperCase();
        if (oldNode.tagName === tagName && newNode.tagName === tagName) {
          var oldStyle = oldNode.getAttribute('style');
          if (oldStyle) newNode.setAttribute('style', oldStyle);
        }
      }

      // Preserve temporary view transition name
      if (oldNode instanceof HTMLElement && newNode instanceof HTMLElement && oldNode.style.viewTransitionName) {
        newNode.style.viewTransitionName = oldNode.style.viewTransitionName;
      }
    }
  },
  onAfterUpdate: function onAfterUpdate(node) {
    if (node instanceof _theme_component__WEBPACK_IMPORTED_MODULE_0__.Component) {
      queueMicrotask(function () {
        return node.updatedCallback();
      });
    }
  }
};

/**
 * Morphs one DOM tree into another by comparing nodes and applying minimal changes
 * @param {Node} oldTree - The existing DOM tree
 * @param {Node | string} newTree - The new DOM tree to morph to
 * @param {Options} [options] - Configuration options
 * @returns {Node} The morphed DOM tree
 */
function morph(oldTree, newTree) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : MORPH_OPTIONS;
  if (!oldTree || !newTree) {
    throw new Error('Both oldTree and newTree must be provided');
  }
  if (typeof newTree === 'string') {
    var parsedNewTree = new DOMParser().parseFromString(newTree, 'text/html').body.firstChild;
    if (!parsedNewTree) {
      throw new Error('newTree string is not valid HTML');
    }
    newTree = parsedNewTree;
  }
  if (options.childrenOnly) {
    updateChildren(newTree, oldTree, options);
    return oldTree;
  }
  if (newTree.nodeType === 11) {
    throw new Error('newTree should have one root node (not a DocumentFragment)');
  }
  return walk(newTree, oldTree, options);
}

/**
 * Walk and morph a dom tree
 * @param {Node} newNode - The new node to morph to
 * @param {Node} oldNode - The old node to morph from
 * @param {Options} options - The options object
 * @returns {Node} The new node or the morphed old node
 */
function walk(newNode, oldNode, options) {
  var _newNode$isSameNode, _options$onAfterUpdat;
  // Skip morphing if there is no old or new node
  if (!oldNode) return newNode;
  if (!newNode) return oldNode;

  // Skip morphing if nodes are identical
  if ((_newNode$isSameNode = newNode.isSameNode) !== null && _newNode$isSameNode !== void 0 && _newNode$isSameNode.call(newNode, oldNode)) return oldNode;

  // Check node type and tag name first
  if (newNode.nodeType !== oldNode.nodeType) return newNode;
  if (newNode instanceof Element && oldNode instanceof Element) {
    // Skip morphing if the node is shopify-accelerated-checkout-cart https://shopify.dev/docs/storefronts/themes/pricing-payments/accelerated-checkout#implement-accelerated-checkout-buttons-on-cart
    if (oldNode.tagName === 'SHOPIFY-ACCELERATED-CHECKOUT-CART') return oldNode;
    if (newNode.tagName !== oldNode.tagName) return newNode;

    // Only check keys for elements, and only if both nodes have keys
    var newKey = getNodeKey(newNode, options);
    var oldKey = getNodeKey(oldNode, options);
    if (newKey && oldKey && newKey !== oldKey) return newNode;
  }

  // We can morph, update the node and its children
  if (oldNode instanceof Element && oldNode.hasAttribute('data-skip-node-update') && newNode instanceof Element && newNode.hasAttribute('data-skip-node-update')) {
    // This is a special case where we don't want to morph the node, but we want to morph the children
    updateChildren(newNode, oldNode, options);
  } else {
    updateNode(newNode, oldNode, options);
    updateChildren(newNode, oldNode, options);
  }
  (_options$onAfterUpdat = options.onAfterUpdate) === null || _options$onAfterUpdat === void 0 || _options$onAfterUpdat.call(options, newNode);
  return oldNode;
}

/**
 * Core morphing function that updates attributes and special elements
 * @param {Node} newNode - Source node with desired state
 * @param {Node} oldNode - Target node to update
 * @param {Options} options - The options object
 */
function updateNode(newNode, oldNode, options) {
  var _options$onBeforeUpda;
  (_options$onBeforeUpda = options.onBeforeUpdate) === null || _options$onBeforeUpda === void 0 || _options$onBeforeUpda.call(options, oldNode, newNode);
  if (newNode instanceof HTMLDetailsElement && oldNode instanceof HTMLDetailsElement || newNode instanceof HTMLDialogElement && oldNode instanceof HTMLDialogElement) {
    if (!newNode.hasAttribute('declarative-open')) {
      newNode.open = oldNode.open;
    }
  }
  if (oldNode instanceof HTMLElement && newNode instanceof HTMLElement) {
    for (var _i3 = 0, _arr = ['slot', 'sizes']; _i3 < _arr.length; _i3++) {
      var attr = _arr[_i3];
      var oldValue = oldNode.getAttribute(attr);
      var newValue = newNode.getAttribute(attr);
      if (oldValue !== newValue) {
        oldValue == null ? newNode.removeAttribute(attr) : newNode.setAttribute(attr, oldValue);
      }
    }
  }
  if (newNode instanceof Element && oldNode instanceof Element) {
    if (!oldNode.isEqualNode(newNode)) {
      copyAttributes(newNode, oldNode);
    }
  } else if (newNode instanceof Text || newNode instanceof Comment) {
    if (oldNode.nodeValue !== newNode.nodeValue) {
      oldNode.nodeValue = newNode.nodeValue;
    }
  }

  // Handle special elements
  if (newNode instanceof HTMLInputElement && oldNode instanceof HTMLInputElement) {
    updateInput(newNode, oldNode);
  } else if (newNode instanceof HTMLOptionElement && oldNode instanceof HTMLOptionElement) {
    updateAttribute(newNode, oldNode, 'selected');
  } else if (newNode instanceof HTMLTextAreaElement && oldNode instanceof HTMLTextAreaElement) {
    updateTextarea(newNode, oldNode);
  }
}

/**
 * Gets a node's key using the getNodeKey option if provided
 * @param {Node | undefined} node - The node to get the key from
 * @param {Options} [options] - The options object that may contain getNodeKey
 * @returns {string|number|undefined} The node's key if one exists
 */
function getNodeKey(node, options) {
  var _options$getNodeKey, _options$getNodeKey2;
  return (_options$getNodeKey = options === null || options === void 0 || (_options$getNodeKey2 = options.getNodeKey) === null || _options$getNodeKey2 === void 0 ? void 0 : _options$getNodeKey2.call(options, node)) !== null && _options$getNodeKey !== void 0 ? _options$getNodeKey : node instanceof Element ? node.id : undefined;
}

/**
 * Updates a boolean attribute and its corresponding property on an element
 * @param {any} newNode - The new element
 * @param {any} oldNode - The existing element to update
 * @param {string} name - The name of the attribute/property to update
 */
function updateAttribute(newNode, oldNode, name) {
  if (newNode[name] !== oldNode[name]) {
    oldNode[name] = newNode[name];
    if (newNode[name] != null) {
      oldNode.setAttribute(name, '');
    } else {
      oldNode.removeAttribute(name);
    }
  }
}

/**
 * Copies attributes from a new node to an old node, handling namespaced attributes
 * @param {Element} newNode - The new node to copy attributes from
 * @param {Element} oldNode - The existing node to update attributes on
 */
function copyAttributes(newNode, oldNode) {
  var oldAttrs = oldNode.attributes;
  var newAttrs = newNode.attributes;

  // Update or add new attributes
  for (var _i4 = 0, _Array$from = Array.from(newAttrs); _i4 < _Array$from.length; _i4++) {
    var attr = _Array$from[_i4];
    var attrName = attr.name,
      attrNamespaceURI = attr.namespaceURI,
      attrValue = attr.value;
    var localName = attr.localName || attrName;
    if (attrName === 'src' || attrName === 'href' || attrName === 'srcset' || attrName === 'poster') {
      // Skip updating resource attributes when the value hasn't changed
      // to prevent unnecessary network requests
      if (oldNode.getAttribute(attrName) === attrValue) continue;
    }
    if (attrNamespaceURI) {
      var fromValue = oldNode.getAttributeNS(attrNamespaceURI, localName);
      if (fromValue !== attrValue) {
        oldNode.setAttributeNS(attrNamespaceURI, localName, attrValue);
      }
    } else {
      if (!oldNode.hasAttribute(attrName)) {
        oldNode.setAttribute(attrName, attrValue);
      } else {
        var _fromValue = oldNode.getAttribute(attrName);
        if (_fromValue !== attrValue) {
          if (attrValue === 'null' || attrValue === 'undefined') {
            oldNode.removeAttribute(attrName);
          } else {
            oldNode.setAttribute(attrName, attrValue);
          }
        }
      }
    }
  }

  // Remove old attributes not present in new node
  for (var _i5 = 0, _Array$from2 = Array.from(oldAttrs); _i5 < _Array$from2.length; _i5++) {
    var _attr = _Array$from2[_i5];
    if (_attr.specified === false) continue;
    var _attrName = _attr.name,
      _attrNamespaceURI = _attr.namespaceURI;
    var _localName = _attr.localName || _attrName;
    if (_attrNamespaceURI) {
      if (!newNode.hasAttributeNS(_attrNamespaceURI, _localName)) {
        oldNode.removeAttributeNS(_attrNamespaceURI, _localName);
      }
    } else if (!newNode.hasAttribute(_attrName)) {
      oldNode.removeAttribute(_attrName);
    }
  }
}

/**
 * Updates special properties and attributes on input elements
 * Handles checked, disabled, indeterminate states and value
 * @param {HTMLInputElement} newNode - The new input element
 * @param {HTMLInputElement} oldNode - The existing input element to update
 */
function updateInput(newNode, oldNode) {
  var newValue = newNode.value;
  updateAttribute(newNode, oldNode, 'checked');
  updateAttribute(newNode, oldNode, 'disabled');

  // Handle indeterminate state (cannot be set via HTML attribute)
  if (newNode.indeterminate !== oldNode.indeterminate) {
    oldNode.indeterminate = newNode.indeterminate;
  }

  // Skip file inputs since they can't be changed programmatically
  if (oldNode.type === 'file') return;
  if (newValue !== oldNode.value) {
    oldNode.setAttribute('value', newValue);
    oldNode.value = newValue;
  }
  if (newValue === 'null') {
    oldNode.value = '';
    oldNode.removeAttribute('value');
  }
  if (!newNode.hasAttributeNS(null, 'value')) {
    oldNode.removeAttribute('value');
  } else if (oldNode.type === 'range') {
    // Update range input UI
    oldNode.value = newValue;
  }
}

/**
 * Updates the value of a textarea element
 * @param {HTMLTextAreaElement} newNode - The new textarea element
 * @param {HTMLTextAreaElement} oldNode - The existing textarea element to update
 */
function updateTextarea(newNode, oldNode) {
  var newValue = newNode.value;
  if (newValue !== oldNode.value) {
    oldNode.value = newValue;
  }
  var firstChild = oldNode.firstChild;
  if ((firstChild === null || firstChild === void 0 ? void 0 : firstChild.nodeType) === Node.TEXT_NODE) {
    if (newValue === '' && firstChild.nodeValue === oldNode.placeholder) {
      return;
    }
    firstChild.nodeValue = newValue;
  }
}

/**
 * Update the children of elements
 * @param {Node} newNode - The new node to update children on
 * @param {Node} oldNode - The existing node to update children on
 * @param {Options} options - The options object
 */
function updateChildren(newNode, oldNode, options) {
  if (oldNode instanceof Element && oldNode.hasAttribute('data-skip-subtree-update') && newNode instanceof Element && newNode.hasAttribute('data-skip-subtree-update')) {
    return;
  }
  var oldChild, newChild, morphed, oldMatch;
  var offset = 0;
  for (var i = 0;; i++) {
    var _options$reject;
    oldChild = oldNode.childNodes[i];
    newChild = newNode.childNodes[i - offset];

    // Both nodes are empty, do nothing
    if (!oldChild && !newChild) {
      break;
    }

    // There is no new child, remove old
    if (!newChild) {
      oldChild && oldNode.removeChild(oldChild);
      i--;
      continue;
    }

    // There is no old child, add new
    if (!oldChild) {
      oldNode.appendChild(newChild);
      offset++;
      continue;
    }

    // Both nodes are the same, morph
    if (same(newChild, oldChild, options)) {
      morphed = walk(newChild, oldChild, options);
      if (morphed !== oldChild) {
        oldNode.replaceChild(morphed, oldChild);
        offset++;
      }
      continue;
    }
    if ((_options$reject = options.reject) !== null && _options$reject !== void 0 && _options$reject.call(options, oldChild, newChild)) {
      newNode.removeChild(newChild);
      i--;
      continue;
    }

    // Try to find a matching node to reorder
    oldMatch = null;
    for (var j = i; j < oldNode.childNodes.length; j++) {
      var potentialOldNode = oldNode.childNodes[j];
      if (potentialOldNode && same(potentialOldNode, newChild, options)) {
        oldMatch = potentialOldNode;
        break;
      }
    }
    if (oldMatch) {
      morphed = walk(newChild, oldMatch, options);
      if (morphed !== oldMatch) offset++;
      oldNode.insertBefore(morphed, oldChild);
    } else if (!getNodeKey(newChild, options) && !getNodeKey(oldChild, options)) {
      // Safe to morph in-place if neither has a key
      morphed = walk(newChild, oldChild, options);
      if (morphed !== oldChild) {
        oldNode.replaceChild(morphed, oldChild);
        offset++;
      }
    } else {
      // Insert the node if we couldn't morph or find a match
      oldNode.insertBefore(newChild, oldChild);
      offset++;
    }
  }
}

/**
 * Check if two nodes are the same
 * @param {Node} a - The first node
 * @param {Node} b - The second node
 * @param {Options} options - The options object
 * @returns {boolean} True if the nodes are the same, false otherwise
 */
function same(a, b, options) {
  var _a$nodeValue, _b$nodeValue;
  // If node types don't match, they're not the same
  if (a.nodeType !== b.nodeType) return false;

  // For elements, check tag name first
  if (a.nodeType === Node.ELEMENT_NODE) {
    if (a instanceof Element && b instanceof Element && a.tagName !== b.tagName) return false;

    // Only compare keys if both nodes have them
    var aKey = getNodeKey(a, options);
    var bKey = getNodeKey(b, options);
    if (aKey && bKey && aKey !== bKey) return false;
  }

  // For text/comment nodes, compare content
  if (a.nodeType === Node.TEXT_NODE && b.nodeType === Node.TEXT_NODE)
    // Trim whitespace to avoid false negatives
    return ((_a$nodeValue = a.nodeValue) === null || _a$nodeValue === void 0 ? void 0 : _a$nodeValue.trim()) === ((_b$nodeValue = b.nodeValue) === null || _b$nodeValue === void 0 ? void 0 : _b$nodeValue.trim());
  if (a.nodeType === Node.COMMENT_NODE && b.nodeType === Node.COMMENT_NODE) return a.nodeValue === b.nodeValue;

  // If we get here and nodes are elements with same tag (and compatible keys), they're the same
  return true;
}

/***/ }),

/***/ "./assets/section-renderer.js":
/*!************************************!*\
  !*** ./assets/section-renderer.js ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   morphSection: () => (/* binding */ morphSection),
/* harmony export */   sectionRenderer: () => (/* binding */ sectionRenderer)
/* harmony export */ });
/* harmony import */ var _theme_morph__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @theme/morph */ "./assets/morph.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }


/**
 * A class to re-render sections using the Section Rendering API
 */
var _cache = /*#__PURE__*/new WeakMap();
var _abortControllersBySectionId = /*#__PURE__*/new WeakMap();
var _pendingPromises = /*#__PURE__*/new WeakMap();
var _SectionRenderer_brand = /*#__PURE__*/new WeakSet();
var SectionRenderer = /*#__PURE__*/function () {
  function SectionRenderer() {
    _classCallCheck(this, SectionRenderer);
    /**
     * Aborts an existing morph for a section
     * @param {string} sectionId - The section ID
     */
    _classPrivateMethodInitSpec(this, _SectionRenderer_brand);
    /**
     * The cache of section HTML
     * @type {Map<string, string>}
     */
    _classPrivateFieldInitSpec(this, _cache, new Map());
    /**
     * The abort controllers by section ID
     * @type {Map<string, AbortController>}
     */
    _classPrivateFieldInitSpec(this, _abortControllersBySectionId, new Map());
    /**
     * The pending promises
     * @type {Map<string, Promise<string>>}
     */
    _classPrivateFieldInitSpec(this, _pendingPromises, new Map());
    window.addEventListener('load', _assertClassBrand(_SectionRenderer_brand, this, _cachePageSections).bind(this));
  }

  /**
   * Renders a section
   * @param {string} sectionId - The section ID
   * @param {Object} [options] - The options
   * @param {boolean} [options.cache] - Whether to use the cache
   * @returns {Promise<string>} The rendered section HTML
   */
  return _createClass(SectionRenderer, [{
    key: "renderSection",
    value: (function () {
      var _renderSection = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(sectionId, options) {
        var _ref, _ref$cache, cache, abortController, sectionHTML;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _ref = options !== null && options !== void 0 ? options : {}, _ref$cache = _ref.cache, cache = _ref$cache === void 0 ? !Shopify.designMode : _ref$cache;
              _assertClassBrand(_SectionRenderer_brand, this, _abortPendingMorph).call(this, sectionId);
              abortController = new AbortController();
              _classPrivateFieldGet(_abortControllersBySectionId, this).set(sectionId, abortController);
              _context.n = 1;
              return this.getSectionHTML(sectionId, cache);
            case 1:
              sectionHTML = _context.v;
              if (!abortController.signal.aborted) {
                _classPrivateFieldGet(_abortControllersBySectionId, this)["delete"](sectionId);
                morphSection(sectionId, sectionHTML);
              }
              return _context.a(2, sectionHTML);
          }
        }, _callee, this);
      }));
      function renderSection(_x, _x2) {
        return _renderSection.apply(this, arguments);
      }
      return renderSection;
    }())
  }, {
    key: "getSectionHTML",
    value: (
    /**
     * Gets the HTML for a section
     * @param {string} sectionId - The section ID
     * @param {boolean} useCache - Whether to use the cache
     * @param {URL} url - The URL to render the section for
     * @returns {Promise<string>} The rendered section HTML
     */
    function () {
      var _getSectionHTML = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(sectionId) {
        var useCache,
          url,
          sectionUrl,
          pendingPromise,
          cachedHTML,
          sectionHTML,
          _args2 = arguments;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              useCache = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : true;
              url = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : new URL(window.location.href);
              sectionUrl = buildSectionRenderingURL(sectionId, url);
              pendingPromise = _classPrivateFieldGet(_pendingPromises, this).get(sectionUrl);
              if (!pendingPromise) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, pendingPromise);
            case 1:
              if (!useCache) {
                _context2.n = 2;
                break;
              }
              cachedHTML = _classPrivateFieldGet(_cache, this).get(sectionUrl);
              if (!cachedHTML) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2, cachedHTML);
            case 2:
              pendingPromise = fetch(sectionUrl).then(function (response) {
                return response.text();
              });
              _classPrivateFieldGet(_pendingPromises, this).set(sectionUrl, pendingPromise);
              _context2.n = 3;
              return pendingPromise;
            case 3:
              sectionHTML = _context2.v;
              _classPrivateFieldGet(_pendingPromises, this)["delete"](sectionUrl);
              _classPrivateFieldGet(_cache, this).set(sectionUrl, sectionHTML);
              return _context2.a(2, sectionHTML);
          }
        }, _callee2, this);
      }));
      function getSectionHTML(_x3) {
        return _getSectionHTML.apply(this, arguments);
      }
      return getSectionHTML;
    }()
    /**
     * Caches the page sections
     */
    )
  }]);
}();
function _abortPendingMorph(sectionId) {
  var existingAbortController = _classPrivateFieldGet(_abortControllersBySectionId, this).get(sectionId);
  if (existingAbortController) {
    existingAbortController.abort();
  }
}
function _cachePageSections() {
  var _iterator = _createForOfIteratorHelper(document.querySelectorAll('.shopify-section')),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var section = _step.value;
      var url = buildSectionRenderingURL(section.id);
      if (_classPrivateFieldGet(_cache, this).get(url)) return;
      if (containsShadowRoot(section)) return;
      _classPrivateFieldGet(_cache, this).set(url, section.outerHTML);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
var SECTION_ID_PREFIX = 'shopify-section-';

/**
 * Builds a section rendering URL
 * @param {string} sectionId - The section ID
 * @param {URL} url - The URL to render the section for
 * @returns {string} The section rendering URL
 */
function buildSectionRenderingURL(sectionId) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new URL(window.location.href);
  url.searchParams.set('section_id', normalizeSectionId(sectionId));
  url.searchParams.sort();
  return url.toString();
}

/**
 * Builds a section selector
 * @param {string} sectionId - The section ID
 * @returns {string} The section selector
 */
function buildSectionSelector(sectionId) {
  return "".concat(SECTION_ID_PREFIX).concat(sectionId);
}

/**
 * Normalizes a section ID
 * @param {string} sectionId - The section ID
 * @returns {string} The normalized section ID
 */
function normalizeSectionId(sectionId) {
  return sectionId.replace(new RegExp("^".concat(SECTION_ID_PREFIX)), '');
}

/**
 * Checks if an element contains a shadow root
 * @param {Element} element - The element to check
 * @returns {boolean} Whether the element contains a shadow root
 */
function containsShadowRoot(element) {
  return !!element.shadowRoot || Array.from(element.children).some(containsShadowRoot);
}

/**
 * @typedef {(previousElement: HTMLElement, newElement: HTMLElement) => void} UpdateCallback
 */

/**
 * Morphs the existing section element with the new section contents
 *
 * @param {string} sectionId - The section ID
 * @param {string} html - The new markup the section should morph into
 */
function morphSection(_x4, _x5) {
  return _morphSection.apply(this, arguments);
}
function _morphSection() {
  _morphSection = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(sectionId, html) {
    var fragment, existingElement, newElement;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          fragment = new DOMParser().parseFromString(html, 'text/html');
          existingElement = document.getElementById(buildSectionSelector(sectionId));
          newElement = fragment.getElementById(buildSectionSelector(sectionId));
          if (existingElement) {
            _context3.n = 1;
            break;
          }
          throw new Error("Section ".concat(sectionId, " not found"));
        case 1:
          if (newElement) {
            _context3.n = 2;
            break;
          }
          throw new Error("Section ".concat(sectionId, " not found in the section rendering response"));
        case 2:
          (0,_theme_morph__WEBPACK_IMPORTED_MODULE_0__.morph)(existingElement, newElement);
        case 3:
          return _context3.a(2);
      }
    }, _callee3);
  }));
  return _morphSection.apply(this, arguments);
}
var sectionRenderer = new SectionRenderer();

/***/ }),

/***/ "./assets/utilities.js":
/*!*****************************!*\
  !*** ./assets/utilities.js ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TextComponent: () => (/* binding */ TextComponent),
/* harmony export */   center: () => (/* binding */ center),
/* harmony export */   changeMetaThemeColor: () => (/* binding */ changeMetaThemeColor),
/* harmony export */   clamp: () => (/* binding */ clamp),
/* harmony export */   closest: () => (/* binding */ closest),
/* harmony export */   debounce: () => (/* binding */ debounce),
/* harmony export */   fetchConfig: () => (/* binding */ fetchConfig),
/* harmony export */   formatMoney: () => (/* binding */ formatMoney),
/* harmony export */   getIOSVersion: () => (/* binding */ getIOSVersion),
/* harmony export */   getVisibleElements: () => (/* binding */ getVisibleElements),
/* harmony export */   isClickedOutside: () => (/* binding */ isClickedOutside),
/* harmony export */   isDesktopBreakpoint: () => (/* binding */ isDesktopBreakpoint),
/* harmony export */   isMobileBreakpoint: () => (/* binding */ isMobileBreakpoint),
/* harmony export */   isPointWithinElement: () => (/* binding */ isPointWithinElement),
/* harmony export */   mediaQueryLarge: () => (/* binding */ mediaQueryLarge),
/* harmony export */   normalizeString: () => (/* binding */ normalizeString),
/* harmony export */   onAnimationEnd: () => (/* binding */ onAnimationEnd),
/* harmony export */   onDocumentLoaded: () => (/* binding */ onDocumentLoaded),
/* harmony export */   prefersReducedMotion: () => (/* binding */ prefersReducedMotion),
/* harmony export */   preloadImage: () => (/* binding */ preloadImage),
/* harmony export */   preventDefault: () => (/* binding */ preventDefault),
/* harmony export */   requestIdleCallback: () => (/* binding */ requestIdleCallback),
/* harmony export */   requestYieldCallback: () => (/* binding */ requestYieldCallback),
/* harmony export */   resetShimmer: () => (/* binding */ resetShimmer),
/* harmony export */   scheduler: () => (/* binding */ scheduler),
/* harmony export */   start: () => (/* binding */ start),
/* harmony export */   startViewTransition: () => (/* binding */ startViewTransition),
/* harmony export */   supportsViewTransitions: () => (/* binding */ supportsViewTransitions),
/* harmony export */   throttle: () => (/* binding */ throttle),
/* harmony export */   viewTransition: () => (/* binding */ viewTransition)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/**
 * Request an idle callback or fallback to setTimeout
 * @returns {function} The requestIdleCallback function
 */
var requestIdleCallback = typeof window.requestIdleCallback == 'function' ? window.requestIdleCallback : setTimeout;

/**
 * Executes a callback in a separate task after the next frame.
 * Using to defer non-critical tasks until after the interaction is complete.
 * @see https://web.dev/articles/optimize-inp#yield_to_allow_rendering_work_to_occur_sooner
 * @param {() => any} callback - The callback to execute
 */
var requestYieldCallback = function requestYieldCallback(callback) {
  requestAnimationFrame(function () {
    setTimeout(callback, 0);
  });
};

/**
 * Check if the browser supports View Transitions API
 * @returns {boolean} True if the browser supports View Transitions API, false otherwise
 */
function supportsViewTransitions() {
  return typeof document.startViewTransition === 'function';
}

/**
 * The current view transition
 * @type {{ current: Promise<void> | undefined }}
 */
var viewTransition = {
  current: undefined
};

/**
 * Functions to run when a view transition of a given type is started
 * @type {{ [key: string]: () => Promise<(() => void) | undefined> }}
 */
var viewTransitionTypes = {
  'product-grid': function () {
    var _productGrid = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var grid, productCards;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            grid = document.querySelector('.product-grid');
            productCards = /** @type {HTMLElement[]} */_toConsumableArray(document.querySelectorAll('.product-grid .product-grid__item'));
            if (!(!grid || !productCards.length)) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            _context.n = 2;
            return new Promise(function (resolve) {
              return requestIdleCallback(function () {
                var cardsToAnimate = getCardsToAnimate(grid, productCards);
                productCards.forEach(function (card, index) {
                  if (index < cardsToAnimate) {
                    card.style.setProperty('view-transition-name', "product-card-".concat(card.dataset.productId));
                  } else {
                    card.style.setProperty('content-visibility', 'hidden');
                  }
                });
                resolve(null);
              });
            });
          case 2:
            return _context.a(2, function () {
              return productCards.forEach(function (card) {
                card.style.removeProperty('view-transition-name');
                card.style.removeProperty('content-visibility');
              });
            });
        }
      }, _callee);
    }));
    function productGrid() {
      return _productGrid.apply(this, arguments);
    }
    return productGrid;
  }()
};

/**
 * Starts a view transition
 * @param {() => void} callback The callback to call when the view transition starts
 * @param {string[]} [types] The types of view transition to use
 * @returns {Promise<void>} A promise that resolves when the view transition finishes
 */
function startViewTransition(callback, types) {
  return new Promise(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(resolve) {
      var cleanupFunctions, _iterator, _step, type, cleanupFunction, transition, _t;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            if (!(supportsViewTransitions() && !prefersReducedMotion())) {
              _context2.n = 9;
              break;
            }
            cleanupFunctions = [];
            if (!types) {
              _context2.n = 8;
              break;
            }
            _iterator = _createForOfIteratorHelper(types);
            _context2.p = 1;
            _iterator.s();
          case 2:
            if ((_step = _iterator.n()).done) {
              _context2.n = 5;
              break;
            }
            type = _step.value;
            if (!viewTransitionTypes[type]) {
              _context2.n = 4;
              break;
            }
            _context2.n = 3;
            return viewTransitionTypes[type]();
          case 3:
            cleanupFunction = _context2.v;
            if (cleanupFunction) cleanupFunctions.push(cleanupFunction);
          case 4:
            _context2.n = 2;
            break;
          case 5:
            _context2.n = 7;
            break;
          case 6:
            _context2.p = 6;
            _t = _context2.v;
            _iterator.e(_t);
          case 7:
            _context2.p = 7;
            _iterator.f();
            return _context2.f(7);
          case 8:
            transition = document.startViewTransition(callback);
            if (!viewTransition.current) {
              viewTransition.current = transition.finished;
            }
            if (types) types.forEach(function (type) {
              return transition.types.add(type);
            });
            transition.finished.then(function () {
              viewTransition.current = undefined;
              cleanupFunctions.forEach(function (cleanupFunction) {
                return cleanupFunction();
              });
              resolve();
            });
            return _context2.a(2);
          case 9:
            // Fallback for browsers that don't support this API yet
            callback();
            resolve();
          case 10:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 6, 7, 8]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
}

/**
 * @typedef {{ [key: string]: string | undefined }} Headers
 */

/**
 * @typedef {Object} FetchConfig
 * @property {string} method
 * @property {Headers} headers
 * @property {string | FormData | undefined} [body]
 */

/**
 * Creates a fetch configuration object
 * @param {string} [type] The type of response to expect
 * @param {Object} [config] The config of the request
 * @param {FetchConfig['body']} [config.body] The body of the request
 * @param {FetchConfig['headers']} [config.headers] The headers of the request
 * @returns {RequestInit} The fetch configuration object
 */
function fetchConfig() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'json';
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  /** @type {Headers} */
  var headers = _objectSpread({
    'Content-Type': 'application/json',
    Accept: "application/".concat(type)
  }, config.headers);
  if (type === 'javascript') {
    headers['X-Requested-With'] = 'XMLHttpRequest';
    delete headers['Content-Type'];
  }
  return {
    method: 'POST',
    headers: (/** @type {HeadersInit} */headers),
    body: config.body
  };
}

/**
 * Creates a debounced function that delays calling the provided function (fn)
 * until after wait milliseconds have elapsed since the last time
 * the debounced function was invoked. The returned function has a .cancel()
 * method to cancel any pending calls.
 *
 * @template {(...args: any[]) => any} T
 * @param {T} fn The function to debounce
 * @param {number} wait The time (in milliseconds) to wait before calling fn
 * @returns {T & { cancel(): void }} A debounced version of fn with a .cancel() method
 */
function debounce(fn, wait) {
  /** @type {number | undefined} */
  var timeout;

  /** @param {...any} args */
  function debounced() {
    var _this = this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      return fn.apply(_this, args);
    }, wait);
  }

  // Add the .cancel method:
  debounced.cancel = function () {
    clearTimeout(timeout);
  };
  return /** @type {T & { cancel(): void }} */debounced;
}

/**
 * Creates a throttled function that calls the provided function (fn) at most once per every wait milliseconds
 *
 * @template {(...args: any[]) => any} T
 * @param {T} fn The function to throttle
 * @param {number} delay The time (in milliseconds) to wait before calling fn
 * @returns {T & { cancel(): void }} A throttled version of fn with a .cancel() method
 */
function throttle(fn, delay) {
  var lastCall = 0;

  /** @param {...any} args */
  function throttled() {
    var now = performance.now();
    // If the time since the last call exceeds the delay, execute the callback
    if (now - lastCall >= delay) {
      lastCall = now;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      fn.apply(this, args);
    }
  }
  throttled.cancel = function () {
    lastCall = performance.now();
  };
  return /** @type {T & { cancel(): void }} */throttled;
}

/**
 * A media query for reduced motion
 * @type {MediaQueryList}
 */
var reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');

/**
 * Check if the user prefers reduced motion
 * @returns {boolean} True if the user prefers reduced motion, false otherwise
 */
function prefersReducedMotion() {
  return reducedMotion.matches;
}

/**
 * Normalize a string
 * @param {string} str The string to normalize
 * @returns {string} The normalized string
 */
function normalizeString(str) {
  return str.normalize('NFD').replace(/(?:[\^`\xA8\xAF\xB4\xB7\xB8\u02B0-\u034E\u0350-\u0357\u035D-\u0362\u0374\u0375\u037A\u0384\u0385\u0483-\u0487\u0559\u0591-\u05A1\u05A3-\u05BD\u05BF\u05C1\u05C2\u05C4\u064B-\u0652\u0657\u0658\u06DF\u06E0\u06E5\u06E6\u06EA-\u06EC\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F5\u0818\u0819\u0898-\u089F\u08C9-\u08D2\u08E3-\u08FE\u093C\u094D\u0951-\u0954\u0971\u09BC\u09CD\u0A3C\u0A4D\u0ABC\u0ACD\u0AFD-\u0AFF\u0B3C\u0B4D\u0B55\u0BCD\u0C3C\u0C4D\u0CBC\u0CCD\u0D3B\u0D3C\u0D4D\u0DCA\u0E3A\u0E47-\u0E4C\u0E4E\u0EBA\u0EC8-\u0ECC\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F82-\u0F84\u0F86\u0F87\u0FC6\u1037\u1039\u103A\u1063\u1064\u1069-\u106D\u1087-\u108D\u108F\u109A\u109B\u135D-\u135F\u1714\u1715\u1734\u17C9-\u17D3\u17DD\u1939-\u193B\u1A60\u1A75-\u1A7C\u1A7F\u1AB0-\u1ABE\u1AC1-\u1ACB\u1B34\u1B44\u1B6B-\u1B73\u1BAA\u1BAB\u1BE6\u1BF2\u1BF3\u1C36\u1C37\u1C78-\u1C7D\u1CD0-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1D2C-\u1D6A\u1DC4-\u1DCF\u1DF5-\u1DFF\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2CEF-\u2CF1\u2E2F\u302A-\u302F\u3099-\u309C\u30FC\uA66F\uA67C\uA67D\uA67F\uA69C\uA69D\uA6F0\uA6F1\uA700-\uA721\uA788-\uA78A\uA7F8\uA7F9\uA806\uA82C\uA8C4\uA8E0-\uA8F1\uA92B-\uA92E\uA953\uA9B3\uA9C0\uA9E5\uAA7B-\uAA7D\uAABF-\uAAC2\uAAF6\uAB5B-\uAB5F\uAB69-\uAB6B\uABEC\uABED\uFB1E\uFE20-\uFE2F\uFF3E\uFF40\uFF70\uFF9E\uFF9F\uFFE3]|\uD800\uDEE0|\uD801[\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD22-\uDD27\uDD4E\uDD69-\uDD6D\uDEFD-\uDEFF\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC46\uDC70\uDCB9\uDCBA\uDD33\uDD34\uDD73\uDDC0\uDDCA-\uDDCC\uDE35\uDE36\uDEE9\uDEEA\uDF3B\uDF3C\uDF4D\uDF66-\uDF6C\uDF70-\uDF74\uDFCE-\uDFD0\uDFD2\uDFD3\uDFE1\uDFE2]|\uD805[\uDC42\uDC46\uDCC2\uDCC3\uDDBF\uDDC0\uDE3F\uDEB6\uDEB7\uDF2B]|\uD806[\uDC39\uDC3A\uDD3D\uDD3E\uDD43\uDDE0\uDE34\uDE47\uDE99]|\uD807[\uDC3F\uDD42\uDD44\uDD45\uDD97\uDF41\uDF42\uDF5A]|\uD80D[\uDC47-\uDC55]|\uD818\uDD2F|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDD6B\uDD6C\uDF8F-\uDF9F\uDFF0\uDFF1]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD67-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD]|\uD838[\uDC30-\uDC6D\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD839[\uDDEE\uDDEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD46\uDD48-\uDD4A])/g, '').toLowerCase();
}

/**
 * Format a money value
 * @param {string} value The value to format
 * @returns {string} The formatted value
 */
function formatMoney(value) {
  var valueWithNoSpaces = value.replace(' ', '');
  if (valueWithNoSpaces.indexOf(',') === -1) return valueWithNoSpaces;
  if (valueWithNoSpaces.indexOf(',') < valueWithNoSpaces.indexOf('.')) return valueWithNoSpaces.replace(',', '');
  if (valueWithNoSpaces.indexOf('.') < valueWithNoSpaces.indexOf(',')) return valueWithNoSpaces.replace('.', '').replace(',', '.');
  if (valueWithNoSpaces.indexOf(',') !== -1) return valueWithNoSpaces.replace(',', '.');
  return valueWithNoSpaces;
}

/**
 * Check if the document is ready/loaded and call the callback when it is.
 * @param {() => void} callback The function to call when the document is ready.
 */
function onDocumentLoaded(callback) {
  if (document.readyState === 'complete') {
    callback();
  } else {
    window.addEventListener('load', callback);
  }
}

/**
 * Wait for all animations to finish before calling the callback.
 * @param {Element | Element[]} elements The element(s) whose animations to wait for.
 * @param {() => void} [callback] The function to call when all animations are finished.
 * @param {Object} [options] The options to pass to `Element.getAnimations`.
 * @returns {Promise<void>} A promise that resolves when all animations are finished.
 */
function onAnimationEnd(elements, callback) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    subtree: true
  };
  var animations = Array.isArray(elements) ? elements.flatMap(function (element) {
    return element.getAnimations(options);
  }) : elements.getAnimations(options);
  var animationPromises = animations.reduce(function (acc, animation) {
    // Ignore ViewTimeline animations
    if (animation.timeline instanceof DocumentTimeline) {
      acc.push(animation.finished);
    }
    return acc;
  }, /** @type {Promise<Animation>[]} */[]);
  return Promise.allSettled(animationPromises).then(callback);
}

/**
 * Check if the click is outside the element.
 * @param {MouseEvent} event The mouse event.
 * @param {Element} element The element to check.
 * @returns {boolean} True if the click is outside the element, false otherwise.
 */
function isClickedOutside(event, element) {
  if (event.target instanceof HTMLDialogElement || !(event.target instanceof Element)) {
    return !isPointWithinElement(event.clientX, event.clientY, element);
  }
  return !element.contains(event.target);
}

/**
 * Check if a point is within an element.
 * @param {number} x The x coordinate of the point.
 * @param {number} y The y coordinate of the point.
 * @param {Element} element The element to check.
 * @returns {boolean} True if the point is within the element, false otherwise.
 */
function isPointWithinElement(x, y, element) {
  var _element$getBoundingC = element.getBoundingClientRect(),
    left = _element$getBoundingC.left,
    right = _element$getBoundingC.right,
    top = _element$getBoundingC.top,
    bottom = _element$getBoundingC.bottom;
  return x >= left && x <= right && y >= top && y <= bottom;
}

/**
 * A media query for large screens
 * @type {MediaQueryList}
 */
var mediaQueryLarge = matchMedia('(min-width: 750px)');

/**
 * Check if the current breakpoint is mobile
 * @returns {boolean} True if the current breakpoint is mobile, false otherwise
 */
function isMobileBreakpoint() {
  return !mediaQueryLarge.matches;
}

/**
 * Check if the current breakpoint is desktop
 * @returns {boolean} True if the current breakpoint is desktop, false otherwise
 */
function isDesktopBreakpoint() {
  return mediaQueryLarge.matches;
}

/**
 * Clamps a number between a minimum and maximum value.
 * @param {number} value - The input number to clamp.
 * @param {number} min - The minimum value.
 * @param {number} max - The maximum value.
 * @returns {number} The clamped value.
 */
function clamp(value, min, max) {
  return Math.max(min, Math.min(value, max));
}

/**
 * Calculates the center point of an element along the specified axis.
 * @param {Element} element - The DOM element to find the center of.
 * @param {'x' | 'y'} [axis] - The axis ('x' or 'y') to get the center for. If not provided, returns both axes.
 * @template {('x' | 'y')} T
 * @param {T} [axis]
 * @returns {T extends ('x' | 'y') ? number : {x: number, y: number}} The center point along the axis or an object with x and y coordinates.
 */
function center(element, axis) {
  var _element$getBoundingC2 = element.getBoundingClientRect(),
    left = _element$getBoundingC2.left,
    width = _element$getBoundingC2.width,
    top = _element$getBoundingC2.top,
    height = _element$getBoundingC2.height;
  var point = {
    x: left + width / 2,
    y: top + height / 2
  };
  if (axis) return /**  @type {any} */point[axis];
  return /**  @type {any} */point;
}

/**
 * Calculates the start point of an element along the specified axis.
 * @param {Element} element - The DOM element to find the start of.
 * @param {'x' | 'y'} [axis] - The axis ('x' or 'y') to get the start for. If not provided, returns both axes.
 * @returns {number | {x: number, y: number}} The start point along the axis or an object with x and y coordinates.
 */
function start(element, axis) {
  var _element$getBoundingC3 = element.getBoundingClientRect(),
    left = _element$getBoundingC3.left,
    top = _element$getBoundingC3.top;
  var point = {
    x: left,
    y: top
  };
  if (axis) return /**  @type {any} */point[axis];
  return /**  @type {any} */point;
}

/**
 * Finds the value in an array that is closest to a target value.
 * @param {number[]} values - An array of numbers.
 * @param {number} target - The target number to find the closest value to.
 * @returns {number} The value from the array closest to the target.
 */
function closest(values, target) {
  return values.reduce(function (prev, curr) {
    return Math.abs(curr - target) < Math.abs(prev - target) ? curr : prev;
  });
}

/**
 * Prevents the default action of an event.
 * @param {Event} event - The event to prevent the default action of.
 */
function preventDefault(event) {
  event.preventDefault();
}

/**
 * Get the visible elements within a root element.
 * @template {Element} T
 * @param {Element} root - The element within which elements should be visible.
 * @param {T[] | undefined} elements - The elements to check for visibility.
 * @param {number} [ratio=1] - The minimum percentage of the element that must be visible.
 * @param {'x' | 'y'} [axis] - Whether to only check along 'x' axis, 'y' axis, or both if undefined.
 * @returns {T[]} An array containing the visible elements.
 */
function getVisibleElements(root, elements) {
  var ratio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var axis = arguments.length > 3 ? arguments[3] : undefined;
  if (!(elements !== null && elements !== void 0 && elements.length)) return [];
  var rootRect = root.getBoundingClientRect();
  return elements.filter(function (element) {
    var _element$getBoundingC4 = element.getBoundingClientRect(),
      width = _element$getBoundingC4.width,
      height = _element$getBoundingC4.height,
      top = _element$getBoundingC4.top,
      right = _element$getBoundingC4.right,
      left = _element$getBoundingC4.left,
      bottom = _element$getBoundingC4.bottom;
    if (ratio < 1) {
      var intersectionLeft = Math.max(rootRect.left, left);
      var intersectionRight = Math.min(rootRect.right, right);
      var intersectionWidth = Math.max(0, intersectionRight - intersectionLeft);
      if (axis === 'x') {
        return width > 0 && intersectionWidth / width >= ratio;
      }
      var intersectionTop = Math.max(rootRect.top, top);
      var intersectionBottom = Math.min(rootRect.bottom, bottom);
      var intersectionHeight = Math.max(0, intersectionBottom - intersectionTop);
      if (axis === 'y') {
        return height > 0 && intersectionHeight / height >= ratio;
      }
      var intersectionArea = intersectionWidth * intersectionHeight;
      var elementArea = width * height;

      // Check that at least the specified ratio of the element is visible
      return elementArea > 0 && intersectionArea / elementArea >= ratio;
    }
    var isWithinX = left >= rootRect.left && right <= rootRect.right;
    if (axis === 'x') {
      return isWithinX;
    }
    var isWithinY = top >= rootRect.top && bottom <= rootRect.bottom;
    if (axis === 'y') {
      return isWithinY;
    }
    return isWithinX && isWithinY;
  });
}
function getIOSVersion() {
  var _userAgent$match;
  var _navigator = navigator,
    userAgent = _navigator.userAgent;
  var isIOS = /(iPhone|iPad)/i.test(userAgent);
  if (!isIOS) return null;
  var version = (_userAgent$match = userAgent.match(/OS ([\d_]+)/)) === null || _userAgent$match === void 0 ? void 0 : _userAgent$match[1];
  var _ref2 = (version === null || version === void 0 ? void 0 : version.split('_')) || [],
    _ref3 = _slicedToArray(_ref2, 2),
    major = _ref3[0],
    minor = _ref3[1];
  if (!version || !major) return null;
  return {
    fullString: version.replace('_', '.'),
    major: parseInt(major, 10),
    minor: minor ? parseInt(minor, 10) : 0
  };
}

/**
 * Determines which grid items should be animated during a transition.
 * It makes an estimation based on the zoom-out card size because it's
 * the common denominator for both transition states. I.e. transitioning either
 * from 10 to 20 cards the other way around, both need 20 cards to be animated.
 * @param {Element} grid - The grid element
 * @param {Element[]} cards - The cards to animate
 * @returns {number} - Number of cards that should be animated
 */
function getCardsToAnimate(grid, cards) {
  var _cardSample$refs, _cardSample$refs2;
  if (!grid || !cards || cards.length === 0) return 0;
  var itemSample = cards[0];
  if (!itemSample) return 0;

  // Calculate the visible area of the grid for the Y axis. Assume X is always fully visible:
  var gridRect = grid.getBoundingClientRect();
  var visibleArea = {
    top: Math.max(0, gridRect.top),
    bottom: Math.min(window.innerHeight, gridRect.bottom)
  };
  var visibleHeight = Math.round(visibleArea.bottom - visibleArea.top);
  if (visibleHeight <= 0) return 0;

  /** @type {import('@theme/product-card').ProductCard | null} */
  var cardSample = itemSample.querySelector('product-card');
  var gridStyle = getComputedStyle(grid);
  var galleryAspectRatio = (cardSample === null || cardSample === void 0 || (_cardSample$refs = cardSample.refs) === null || _cardSample$refs === void 0 || (_cardSample$refs = _cardSample$refs.cardGallery) === null || _cardSample$refs === void 0 ? void 0 : _cardSample$refs.style.getPropertyValue('--gallery-aspect-ratio')) || '';
  var aspectRatio = parseFloat(galleryAspectRatio) || 0.5;
  if (galleryAspectRatio !== null && galleryAspectRatio !== void 0 && galleryAspectRatio.includes('/')) {
    var _galleryAspectRatio$s = galleryAspectRatio.split('/'),
      _galleryAspectRatio$s2 = _slicedToArray(_galleryAspectRatio$s, 2),
      _galleryAspectRatio$s3 = _galleryAspectRatio$s2[0],
      width = _galleryAspectRatio$s3 === void 0 ? '1' : _galleryAspectRatio$s3,
      _galleryAspectRatio$s4 = _galleryAspectRatio$s2[1],
      height = _galleryAspectRatio$s4 === void 0 ? '2' : _galleryAspectRatio$s4;
    aspectRatio = parseInt(width, 10) / parseInt(height, 10);
  }
  var cardGap = parseInt((cardSample === null || cardSample === void 0 || (_cardSample$refs2 = cardSample.refs) === null || _cardSample$refs2 === void 0 || (_cardSample$refs2 = _cardSample$refs2.productCardLink) === null || _cardSample$refs2 === void 0 ? void 0 : _cardSample$refs2.style.getPropertyValue('--product-card-gap')) || '') || 12;
  var gridGap = parseInt(gridStyle.getPropertyValue('--product-grid-gap')) || 12;

  // Assume only a couple of lines of text in the card details (title and price).
  // If the title wraps into more lines, we might just animate more cards, but that's fine.
  var detailsSize = ((parseInt(gridStyle.fontSize) || 16) + 2) * 2;
  var isMobile = window.innerWidth < 750;

  // Always use the zoom-out state card width
  var cardWidth = isMobile ? Math.round((gridRect.width - gridGap) / 2) : 100;
  var cardHeight = Math.round(cardWidth / aspectRatio) + cardGap + detailsSize;

  // Calculate the number of cards that fit in the visible area:
  // - The width estimation is pretty accurate, we can ignore decimals.
  // - The height estimation needs to account for peeking rows, so we round up.
  var columnsInGrid = isMobile ? 2 : Math.floor((gridRect.width + gridGap) / (cardWidth + gridGap));
  var rowsInGrid = Math.ceil((visibleHeight - gridGap) / (cardHeight + gridGap));
  return columnsInGrid * rowsInGrid;
}

/**
 * Preloads an image
 * @param {string} src - The source of the image to preload
 */
function preloadImage(src) {
  var image = new Image();
  image.src = src;
}
var TextComponent = /*#__PURE__*/function (_HTMLElement) {
  function TextComponent() {
    _classCallCheck(this, TextComponent);
    return _callSuper(this, TextComponent, arguments);
  }
  _inherits(TextComponent, _HTMLElement);
  return _createClass(TextComponent, [{
    key: "shimmer",
    value: function shimmer() {
      this.setAttribute('shimmer', '');
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('text-component')) {
  customElements.define('text-component', TextComponent);
}

/**
 * Resets the shimmer attribute on all elements in the container.
 * @param {Element} [container] - The container to reset the shimmer attribute on.
 */
function resetShimmer() {
  var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
  var shimmer = container.querySelectorAll('[shimmer]');
  shimmer.forEach(function (item) {
    return item.removeAttribute('shimmer');
  });
}

/**
 * Change the meta theme color of the header.
 * @param {Element} colorSourceElement - The HTML element whose background-color will determine the new theme-color.
 */
function changeMetaThemeColor(colorSourceElement) {
  var metaThemeColor = document.head.querySelector('meta[name="theme-color"]');
  var containerStyle = window.getComputedStyle(colorSourceElement);
  if (metaThemeColor) metaThemeColor.setAttribute('content', containerStyle.backgroundColor);
}
var _queue = /*#__PURE__*/new WeakMap();
var _scheduled = /*#__PURE__*/new WeakMap();
var Scheduler = /*#__PURE__*/_createClass(function Scheduler() {
  var _this2 = this;
  _classCallCheck(this, Scheduler);
  /** @type {Set<() => void>} */
  _classPrivateFieldInitSpec(this, _queue, new Set());
  /** @type {boolean} */
  _classPrivateFieldInitSpec(this, _scheduled, false);
  /** @param {() => void} task */
  _defineProperty(this, "schedule", /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(task) {
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            _classPrivateFieldGet(_queue, _this2).add(task);
            if (_classPrivateFieldGet(_scheduled, _this2)) {
              _context3.n = 2;
              break;
            }
            _classPrivateFieldSet(_scheduled, _this2, true);

            // Wait for any in-progress view transitions to finish
            if (!viewTransition.current) {
              _context3.n = 1;
              break;
            }
            _context3.n = 1;
            return viewTransition.current;
          case 1:
            requestAnimationFrame(_this2.flush);
          case 2:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }());
  _defineProperty(this, "flush", function () {
    var _iterator2 = _createForOfIteratorHelper(_classPrivateFieldGet(_queue, _this2)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var task = _step2.value;
        task();
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    _classPrivateFieldGet(_queue, _this2).clear();
    _classPrivateFieldSet(_scheduled, _this2, false);
  });
});
var scheduler = new Scheduler();
Theme.utilities = _objectSpread(_objectSpread({}, Theme.utilities), {}, {
  scheduler: scheduler
});

/***/ }),

/***/ "./src/js/helpers/events.js":
/*!**********************************!*\
  !*** ./src/js/helpers/events.js ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CartAddEvent: () => (/* binding */ CartAddEvent),
/* harmony export */   CartErrorEvent: () => (/* binding */ CartErrorEvent),
/* harmony export */   CartUpdateEvent: () => (/* binding */ CartUpdateEvent),
/* harmony export */   DiscountUpdateEvent: () => (/* binding */ DiscountUpdateEvent),
/* harmony export */   FilterUpdateEvent: () => (/* binding */ FilterUpdateEvent),
/* harmony export */   MediaStartedPlayingEvent: () => (/* binding */ MediaStartedPlayingEvent),
/* harmony export */   MegaMenuHoverEvent: () => (/* binding */ MegaMenuHoverEvent),
/* harmony export */   QuantitySelectorUpdateEvent: () => (/* binding */ QuantitySelectorUpdateEvent),
/* harmony export */   SlideshowSelectEvent: () => (/* binding */ SlideshowSelectEvent),
/* harmony export */   ThemeEvents: () => (/* binding */ ThemeEvents),
/* harmony export */   VariantSelectedEvent: () => (/* binding */ VariantSelectedEvent),
/* harmony export */   VariantUpdateEvent: () => (/* binding */ VariantUpdateEvent),
/* harmony export */   ZoomMediaSelectedEvent: () => (/* binding */ ZoomMediaSelectedEvent)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @namespace ThemeEvents
 * @description A collection of theme-specific events that can be used to trigger and listen for changes anywhere in the theme.
 * @example
 * document.dispatchEvent(new VariantUpdateEvent(variant, sectionId, { html }));
 * document.addEventListener(ThemeEvents.variantUpdate, (e) => { console.log(e.detail.variant) });
 */
var ThemeEvents = /*#__PURE__*/_createClass(function ThemeEvents() {
  _classCallCheck(this, ThemeEvents);
});

/**
 * Event fired when a variant is selected
 * @extends {Event}
 */
/** @static @constant {string} Event triggered when a variant is selected */
_defineProperty(ThemeEvents, "variantSelected", 'variant:selected');
/** @static @constant {string} Event triggered when a variant is changed */
_defineProperty(ThemeEvents, "variantUpdate", 'variant:update');
/** @static @constant {string} Event triggered when the cart items or quantities are updated */
_defineProperty(ThemeEvents, "cartUpdate", 'cart:update');
/** @static @constant {string} Event triggered when a cart update fails */
_defineProperty(ThemeEvents, "cartError", 'cart:error');
/** @static @constant {string} Event triggered when a media (video, 3d model) is loaded */
_defineProperty(ThemeEvents, "mediaStartedPlaying", 'media:started-playing');
// Event triggered when quantity-selector value is changed
_defineProperty(ThemeEvents, "quantitySelectorUpdate", 'quantity-selector:update');
/** @static @constant {string} Event triggered when a predictive search is expanded */
_defineProperty(ThemeEvents, "megaMenuHover", 'megaMenu:hover');
/** @static @constant {string} Event triggered when a zoom dialog media is selected */
_defineProperty(ThemeEvents, "zoomMediaSelected", 'zoom-media:selected');
/** @static @constant {string} Event triggered when a discount is applied */
_defineProperty(ThemeEvents, "discountUpdate", 'discount:update');
/** @static @constant {string} Event triggered when changing collection filters */
_defineProperty(ThemeEvents, "FilterUpdate", 'filter:update');
var VariantSelectedEvent = /*#__PURE__*/function (_Event) {
  /**
   * Creates a new VariantSelectedEvent
   * @param {Object} resource - The new variant object
   * @param {string} resource.id - The id of the variant
   */
  function VariantSelectedEvent(resource) {
    var _this;
    _classCallCheck(this, VariantSelectedEvent);
    _this = _callSuper(this, VariantSelectedEvent, [ThemeEvents.variantSelected, {
      bubbles: true
    }]);
    _this.detail = {
      resource: resource
    };
    return _this;
  }
  _inherits(VariantSelectedEvent, _Event);
  return _createClass(VariantSelectedEvent);
}(/*#__PURE__*/_wrapNativeSuper(Event));

/**
 * Event fired after a variant is updated
 * @extends {Event}
 */
var VariantUpdateEvent = /*#__PURE__*/function (_Event2) {
  /**
   * Creates a new VariantUpdateEvent
   * @param {Object} resource - The new variant object
   * @param {string} resource.id - The id of the variant
   * @param {boolean} resource.available - Whether the variant is available
   * @param {boolean} resource.inventory_management - Whether the variant has inventory management
   * @param {Object} [resource.featured_media] - The featured media of the variant
   * @param {string} [resource.featured_media.id] - The id of the featured media
   * @param {Object} [resource.featured_media.preview_image] - The preview image of the featured media
   * @param {string} [resource.featured_media.preview_image.src] - The src URL of the preview image
   * @param {string} sourceId - The id of the element the action was triggered from
   * @param {Object} data - Additional event data
   * @param {Document} data.html - The new document fragment for the variant
   * @param {string} data.productId - The product ID of the updated variant, used to ensure the correct product form is updated
   * @param {Object} [data.newProduct] - If a new product was loaded as part of the variant update (combined listing)
   * @param {string} data.newProduct.id - The id of the new product
   * @param {string} data.newProduct.url - The url of the new product
   */
  function VariantUpdateEvent(resource, sourceId, data) {
    var _this2;
    _classCallCheck(this, VariantUpdateEvent);
    _this2 = _callSuper(this, VariantUpdateEvent, [ThemeEvents.variantUpdate, {
      bubbles: true
    }]);
    _this2.detail = {
      resource: resource || null,
      sourceId: sourceId,
      data: {
        html: data.html,
        productId: data.productId,
        newProduct: data.newProduct
      }
    };
    return _this2;
  }
  _inherits(VariantUpdateEvent, _Event2);
  return _createClass(VariantUpdateEvent);
}(/*#__PURE__*/_wrapNativeSuper(Event));

/**
 * Event class for cart additions
 * @extends {Event}
 */
var CartAddEvent = /*#__PURE__*/function (_Event3) {
  /**
   * Creates a new CartAddEvent
   * @param {Object} [resource] - The new cart object
   * @param {string} [sourceId] - The id of the element the action was triggered from
   * @param {Object} [data] - Additional event data
   * @param {boolean} [data.didError] - Whether the cart operation failed
   * @param {string} [data.source] - The source of the cart update
   * @param {string} [data.productId] - The id of the product card that was updated
   * @param {number} [data.itemCount] - The number of items in the cart
   * @param {string} [data.variantId] - The id of the product variant that was added
   * @param {Record<string, string>} [data.sections] - The sections affected by the cart operation
   */
  function CartAddEvent(resource, sourceId, data) {
    var _this3;
    _classCallCheck(this, CartAddEvent);
    _this3 = _callSuper(this, CartAddEvent, [CartAddEvent.eventName, {
      bubbles: true
    }]);
    _this3.detail = {
      resource: resource,
      sourceId: sourceId,
      data: _objectSpread({}, data)
    };
    return _this3;
  }
  _inherits(CartAddEvent, _Event3);
  return _createClass(CartAddEvent);
}(/*#__PURE__*/_wrapNativeSuper(Event));

/**
 * Event class for cart updates
 * @extends {Event}
 */
_defineProperty(CartAddEvent, "eventName", ThemeEvents.cartUpdate);
var CartUpdateEvent = /*#__PURE__*/function (_Event4) {
  /**
   * Creates a new CartUpdateEvent
   * @param {Object} resource - The new cart object
   * @param {string} sourceId - The id of the element the action was triggered from
   * @param {Object} [data] - Additional event data
   * @param {boolean} [data.didError] - Whether the cart operation failed
   * @param {string} [data.source] - The source of the cart update
   * @param {string} [data.productId] - The id of the product card that was updated
   * @param {number} [data.itemCount] - The number of items in the cart
   * @param {string} [data.variantId] - The id of the product variant that was updated
   * @param {Record<string, string>} [data.sections] - The sections affected by the cart operation
   */
  function CartUpdateEvent(resource, sourceId, data) {
    var _this4;
    _classCallCheck(this, CartUpdateEvent);
    _this4 = _callSuper(this, CartUpdateEvent, [ThemeEvents.cartUpdate, {
      bubbles: true
    }]);
    _this4.detail = {
      resource: resource,
      sourceId: sourceId,
      data: _objectSpread({}, data)
    };
    return _this4;
  }
  _inherits(CartUpdateEvent, _Event4);
  return _createClass(CartUpdateEvent);
}(/*#__PURE__*/_wrapNativeSuper(Event));

/**
 * Event class for cart errors
 * @extends {Event}
 */
var CartErrorEvent = /*#__PURE__*/function (_Event5) {
  /**
   * Creates a new CartErrorEvent
   * @param {string} sourceId - The id of the element the action was triggered from
   * @param {string} message - A message from the server response
   * @param {Object} description - Description from the server response
   * @param {Object} errors - Errors from the server response
   */
  function CartErrorEvent(sourceId, message, description, errors) {
    var _this5;
    _classCallCheck(this, CartErrorEvent);
    _this5 = _callSuper(this, CartErrorEvent, [ThemeEvents.cartError, {
      bubbles: true
    }]);
    _this5.detail = {
      sourceId: sourceId,
      data: {
        message: message,
        errors: errors,
        description: description
      }
    };
    return _this5;
  }
  _inherits(CartErrorEvent, _Event5);
  return _createClass(CartErrorEvent);
}(/*#__PURE__*/_wrapNativeSuper(Event));

/**
 * Event class for quantity-selector updates
 * @extends {Event}
 */
var QuantitySelectorUpdateEvent = /*#__PURE__*/function (_Event6) {
  /**
   * Creates a new QuantitySelectorUpdateEvent
   * @param {number} quantity - Quantity value
   * @param {number} [cartLine] - The id of the updated cart line
   */
  function QuantitySelectorUpdateEvent(quantity, cartLine) {
    var _this6;
    _classCallCheck(this, QuantitySelectorUpdateEvent);
    _this6 = _callSuper(this, QuantitySelectorUpdateEvent, [ThemeEvents.quantitySelectorUpdate, {
      bubbles: true
    }]);
    _this6.detail = {
      quantity: quantity,
      cartLine: cartLine
    };
    return _this6;
  }
  _inherits(QuantitySelectorUpdateEvent, _Event6);
  return _createClass(QuantitySelectorUpdateEvent);
}(/*#__PURE__*/_wrapNativeSuper(Event));

/**
 * Event class for quantity-selector updates
 * @extends {Event}
 */
var DiscountUpdateEvent = /*#__PURE__*/function (_Event7) {
  /**
   * Creates a new DiscountUpdateEvent
   * @param {Object} resource - The new cart object
   * @param {string} sourceId - The id of the element the action was triggered from
   */
  function DiscountUpdateEvent(resource, sourceId) {
    var _this7;
    _classCallCheck(this, DiscountUpdateEvent);
    _this7 = _callSuper(this, DiscountUpdateEvent, [ThemeEvents.discountUpdate, {
      bubbles: true
    }]);
    _this7.detail = {
      resource: resource,
      sourceId: sourceId
    };
    return _this7;
  }
  _inherits(DiscountUpdateEvent, _Event7);
  return _createClass(DiscountUpdateEvent);
}(/*#__PURE__*/_wrapNativeSuper(Event));

/**
 * Event class for media playback starts
 * @extends {Event}
 */
var MediaStartedPlayingEvent = /*#__PURE__*/function (_Event8) {
  /**
   * Creates a new MediaStartedPlayingEvent
   * @param {HTMLElement} resource - The element containing the video that emitted the event
   */
  function MediaStartedPlayingEvent(resource) {
    var _this8;
    _classCallCheck(this, MediaStartedPlayingEvent);
    _this8 = _callSuper(this, MediaStartedPlayingEvent, [ThemeEvents.mediaStartedPlaying, {
      bubbles: true
    }]);
    _this8.detail = {
      resource: resource
    };
    return _this8;
  }
  _inherits(MediaStartedPlayingEvent, _Event8);
  return _createClass(MediaStartedPlayingEvent);
}(/*#__PURE__*/_wrapNativeSuper(Event));

/**
 * @typedef {Object} SlideshowSelectEventData
 * @property {number} index
 * @property {string | null} id
 * @property {Element} slide
 * @property {number} previousIndex
 * @property {boolean} userInitiated
 * @property {'select' | 'scroll' | 'drag'} trigger
 */

var SlideshowSelectEvent = /*#__PURE__*/function (_Event9) {
  /**  @param {SlideshowSelectEventData} data */
  function SlideshowSelectEvent(data) {
    var _this9;
    _classCallCheck(this, SlideshowSelectEvent);
    _this9 = _callSuper(this, SlideshowSelectEvent, [SlideshowSelectEvent.eventName, {
      bubbles: true
    }]);
    /** @type {SlideshowSelectEventData} */
    _defineProperty(_this9, "detail", void 0);
    _this9.detail = data;
    return _this9;
  }
  _inherits(SlideshowSelectEvent, _Event9);
  return _createClass(SlideshowSelectEvent);
}(/*#__PURE__*/_wrapNativeSuper(Event));

/**
 * Event class for zoom dialog media selection
 * @extends {Event}
 */
_defineProperty(SlideshowSelectEvent, "eventName", 'slideshow:select');
var ZoomMediaSelectedEvent = /*#__PURE__*/function (_Event0) {
  /**
   * Creates a new ZoomMediaSelectedEvent
   * @param {number} index - The index of the selected media
   */
  function ZoomMediaSelectedEvent(index) {
    var _this0;
    _classCallCheck(this, ZoomMediaSelectedEvent);
    _this0 = _callSuper(this, ZoomMediaSelectedEvent, [ThemeEvents.zoomMediaSelected, {
      bubbles: true
    }]);
    _this0.detail = {
      index: index
    };
    return _this0;
  }
  _inherits(ZoomMediaSelectedEvent, _Event0);
  return _createClass(ZoomMediaSelectedEvent);
}(/*#__PURE__*/_wrapNativeSuper(Event));

/**
 * Event class for mega menu hover being hovered over
 * @extends {Event}
 */
var MegaMenuHoverEvent = /*#__PURE__*/function (_Event1) {
  function MegaMenuHoverEvent() {
    _classCallCheck(this, MegaMenuHoverEvent);
    return _callSuper(this, MegaMenuHoverEvent, [ThemeEvents.megaMenuHover, {
      bubbles: true
    }]);
  }
  _inherits(MegaMenuHoverEvent, _Event1);
  return _createClass(MegaMenuHoverEvent);
}(/*#__PURE__*/_wrapNativeSuper(Event));

/** Event class for facet filtering updates */
var FilterUpdateEvent = /*#__PURE__*/function (_Event10) {
  /** @param {URLSearchParams} queryParams */
  function FilterUpdateEvent(queryParams) {
    var _this1;
    _classCallCheck(this, FilterUpdateEvent);
    _this1 = _callSuper(this, FilterUpdateEvent, [ThemeEvents.FilterUpdate, {
      bubbles: true
    }]);
    _this1.detail = {
      queryParams: queryParams
    };
    return _this1;
  }
  _inherits(FilterUpdateEvent, _Event10);
  return _createClass(FilterUpdateEvent, [{
    key: "shouldShowClearAll",
    value: function shouldShowClearAll() {
      return _toConsumableArray(this.detail.queryParams.entries()).filter(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
          key = _ref2[0];
        return key.startsWith('filter.');
      }).length > 0;
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(Event));

/***/ }),

/***/ "./src/js/helpers/format-money.js":
/*!****************************************!*\
  !*** ./src/js/helpers/format-money.js ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   formatMoney: () => (/* binding */ formatMoney)
/* harmony export */ });
var formatMoney = function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || '${{amount}}';
  function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ',');
    decimal = defaultTo(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
      dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      centsAmount = parts[1] ? decimal + parts[1] : '';
    return dollarsAmount + centsAmount;
  }
  var value = '';
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, ',', '.');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
  }
  if (formatString.indexOf('with_comma_separator') !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
};

/***/ }),

/***/ "./src/js/modules/button.js":
/*!**********************************!*\
  !*** ./src/js/modules/button.js ***!
  \**********************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var EdButton = /*#__PURE__*/function (_HTMLElement) {
  function EdButton() {
    var _this;
    _classCallCheck(this, EdButton);
    _this = _callSuper(this, EdButton);
    _this.addEventListener('click', _this.handleClick.bind(_this));
    return _this;
  }
  _inherits(EdButton, _HTMLElement);
  return _createClass(EdButton, [{
    key: "extractErrorMessage",
    value: function extractErrorMessage(errorMessage) {
      try {
        var match = errorMessage.match(/User errors: (\[.*\])/);
        if (match) {
          var userErrors = JSON.parse(match[1]);
          if (userErrors.length > 0 && userErrors[0].message) {
            return userErrors[0].message;
          }
        }
      } catch (e) {
        console.error('Failed to parse error message:', e);
      }
      return errorMessage;
    }
  }, {
    key: "handleClick",
    value: function () {
      var _handleClick = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
        var _window$Shopify,
          _this2 = this;
        var tag, customerId, appUrl, shop, actionsAdd, actionsAdded, originalText, response, data, info, errorMessage, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              e.preventDefault();
              tag = this.dataset.tag;
              customerId = this.dataset.customerId;
              appUrl = this.dataset.appUrl;
              shop = (_window$Shopify = window.Shopify) === null || _window$Shopify === void 0 ? void 0 : _window$Shopify.shop;
              actionsAdd = this.dataset.actionsAdd || 'Adding';
              actionsAdded = this.dataset.actionsAdded || 'Added';
              if (!(!tag || !customerId || !appUrl || !shop)) {
                _context.n = 1;
                break;
              }
              console.error('Missing required data:', {
                tag: tag,
                customerId: customerId,
                appUrl: appUrl,
                shop: shop
              });
              return _context.a(2);
            case 1:
              originalText = this.textContent;
              this.textContent = actionsAdd + '...';
              this.classList.add('disabled');
              _context.p = 2;
              _context.n = 3;
              return fetch("".concat(appUrl, "/api/customer-tag"), {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  shop: shop,
                  customerId: customerId,
                  tag: tag
                })
              });
            case 3:
              response = _context.v;
              _context.n = 4;
              return response.json();
            case 4:
              data = _context.v;
              if (!(response.status === 200 && data.success)) {
                _context.n = 5;
                break;
              }
              this.textContent = actionsAdded;
              info = this.parentElement.querySelector('.ed-button__info');
              if (info) {
                info.removeAttribute('hidden');
              }
              _context.n = 6;
              break;
            case 5:
              throw new Error(data.message || data.error || 'Failed to add tag');
            case 6:
              _context.n = 8;
              break;
            case 7:
              _context.p = 7;
              _t = _context.v;
              console.error('Error adding tag:', _t);
              errorMessage = this.extractErrorMessage(_t.message);
              this.textContent = errorMessage;
              setTimeout(function () {
                _this2.textContent = originalText;
                _this2.classList.remove('disabled');
              }, 3000);
            case 8:
              return _context.a(2);
          }
        }, _callee, this, [[2, 7]]);
      }));
      function handleClick(_x) {
        return _handleClick.apply(this, arguments);
      }
      return handleClick;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-button', EdButton);

/***/ }),

/***/ "./src/js/modules/ed-article-number.js":
/*!*********************************************!*\
  !*** ./src/js/modules/ed-article-number.js ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _helpers_events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/events */ "./src/js/helpers/events.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }

var ArticleNumber = /*#__PURE__*/function (_HTMLElement) {
  function ArticleNumber() {
    _classCallCheck(this, ArticleNumber);
    return _callSuper(this, ArticleNumber, arguments);
  }
  _inherits(ArticleNumber, _HTMLElement);
  return _createClass(ArticleNumber, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
      this.initializeSkeleton();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.skuElement = this.querySelector('.ed-article-number-sku');
      this.textElement = this.querySelector('.ed-article-number-text');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      document.addEventListener(_helpers_events__WEBPACK_IMPORTED_MODULE_0__.ThemeEvents.variantUpdate, this.handleVariantUpdate.bind(this));
      document.addEventListener(_helpers_events__WEBPACK_IMPORTED_MODULE_0__.ThemeEvents.variantSelected, this.handleVariantSelected.bind(this));
    }
  }, {
    key: "initializeSkeleton",
    value: function initializeSkeleton() {
      var _this$skuElement;
      var currentSku = (_this$skuElement = this.skuElement) === null || _this$skuElement === void 0 ? void 0 : _this$skuElement.textContent.trim();
      if (!currentSku) {
        this.showSkeleton();
      }
    }
  }, {
    key: "handleVariantSelected",
    value: function handleVariantSelected(event) {
      this.showSkeleton();
    }
  }, {
    key: "handleVariantUpdate",
    value: function handleVariantUpdate(event) {
      var _event$detail = event.detail,
        resource = _event$detail.resource,
        data = _event$detail.data;
      if (!resource) {
        this.hideSkeleton();
        return;
      }
      var sku = resource.sku;
      if (sku) {
        this.updateSku(sku);
      } else {
        this.hideSkeleton();
      }
    }
  }, {
    key: "updateSku",
    value: function updateSku(sku) {
      if (!this.skuElement) return;
      var newContent = sku;
      var oldContent = this.skuElement.textContent.trim().replace('...', '').trim();
      if (newContent !== oldContent) {
        this.morphContent(newContent);
      } else {
        this.hideSkeleton();
      }
    }
  }, {
    key: "morphContent",
    value: function morphContent(newSku) {
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = newSku;
      if (this.skuElement) {
        this.skuElement.textContent = newSku;
        this.hideSkeleton();
      }
    }
  }, {
    key: "showSkeleton",
    value: function showSkeleton() {
      if (!this.skuElement) return;
      this.skuElement.textContent = '...';
      this.classList.add('is-loading');
    }
  }, {
    key: "hideSkeleton",
    value: function hideSkeleton() {
      if (!this.skuElement) return;
      var content = this.skuElement.textContent.trim();
      if (!content || content === '...') {
        this.skuElement.textContent = '';
      }
      this.classList.remove('is-loading');
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-article-number')) {
  customElements.define('ed-article-number', ArticleNumber);
}

/***/ }),

/***/ "./src/js/modules/ed-cart-share.js":
/*!*****************************************!*\
  !*** ./src/js/modules/ed-cart-share.js ***!
  \*****************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var EdCartShare = /*#__PURE__*/function (_HTMLElement) {
  function EdCartShare() {
    _classCallCheck(this, EdCartShare);
    return _callSuper(this, EdCartShare, arguments);
  }
  _inherits(EdCartShare, _HTMLElement);
  return _createClass(EdCartShare, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.input = this.querySelector('[data-cart-permalink]');
      this.button = this.querySelector('[data-copy-button]');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      if (this.button) {
        this.button.addEventListener('click', this.copyToClipboard.bind(this));
      }
      if (this.input) {
        this.input.addEventListener('click', this.selectInput.bind(this));
      }
    }
  }, {
    key: "selectInput",
    value: function selectInput() {
      this.input.select();
      this.input.setSelectionRange(0, 99999);
    }
  }, {
    key: "copyToClipboard",
    value: function copyToClipboard() {
      if (!this.input) return;
      this.selectInput();
      navigator.clipboard.writeText(this.input.value)["catch"](function (err) {
        console.error('Fehler beim Kopieren: ', err);
        alert('Link konnte nicht kopiert werden');
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-cart-share')) {
  customElements.define('ed-cart-share', EdCartShare);
}

/***/ }),

/***/ "./src/js/modules/ed-clear-cart-button.js":
/*!************************************************!*\
  !*** ./src/js/modules/ed-clear-cart-button.js ***!
  \************************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var EdClearCartButton = /*#__PURE__*/function (_HTMLElement) {
  function EdClearCartButton() {
    _classCallCheck(this, EdClearCartButton);
    return _callSuper(this, EdClearCartButton, arguments);
  }
  _inherits(EdClearCartButton, _HTMLElement);
  return _createClass(EdClearCartButton, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _this$button;
      (_this$button = this.button) === null || _this$button === void 0 || _this$button.removeEventListener('click', this._onClick);
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.button = this.querySelector('button');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this._onClick = this._handleClick.bind(this);
      this.button.addEventListener('click', this._onClick);
    }
  }, {
    key: "_handleClick",
    value: function () {
      var _handleClick2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
        var response, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              event.preventDefault();
              if (!this.button.disabled) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.p = 1;
              this.button.disabled = true;
              _context.n = 2;
              return fetch("".concat(window.Shopify.routes.root, "cart/clear.js"), {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json'
                }
              });
            case 2:
              response = _context.v;
              if (response.ok) {
                _context.n = 3;
                break;
              }
              throw new Error("Cart clear failed: ".concat(response.status));
            case 3:
              window.location.reload();
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              console.error('Fehler beim Leeren des Warenkorbs:', _t);
            case 5:
              _context.p = 5;
              this.button.disabled = false;
              return _context.f(5);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[1, 4, 5, 6]]);
      }));
      function _handleClick(_x) {
        return _handleClick2.apply(this, arguments);
      }
      return _handleClick;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-clear-cart-button')) {
  customElements.define('ed-clear-cart-button', EdClearCartButton);
}

/***/ }),

/***/ "./src/js/modules/ed-forms-phone-sync.js":
/*!***********************************************!*\
  !*** ./src/js/modules/ed-forms-phone-sync.js ***!
  \***********************************************/
/***/ (() => {

/**
 * ELBDEV / Shopify Forms: phone number only once on the registration form
 *
 * The registration form (Shopify Forms app block on pages/registrierung) asks for the customer phone,
 * which is stored on the customer profile. Every address in the form brings its own phone field as well,
 * which can't be removed in the Forms admin. These address phone fields are hidden and mirror the customer
 * phone including its country code, so customers enter their number only once.
 *
 * Whenever the number can't be passed on (e.g. after changes to the form app), the address phone fields
 * are shown again, so customers can still fill them in and register.
 *
 * Forms and field IDs are set in the theme settings "elbDev/registration-form", passed in snippets/scripts.liquid.
 *
 * Plain module instead of a Web Component: the form markup belongs to the Forms app block (open shadow root),
 * the theme renders no element of its own around it.
 */

/**
 * @param {?string} value - Comma separated list from the theme settings
 * @returns {string[]}
 */
var parseList = function parseList(value) {
  return (value || '').split(',').map(function (item) {
    return item.trim();
  }).filter(Boolean);
};
var settings = window.edFormsPhoneSyncSettings || {};
var FORM_IDS = parseList(settings.formIds);
var CUSTOMER_PHONE_ID = settings.customerPhoneId;
var ADDRESS_PHONE_IDS = parseList(settings.addressPhoneIds);

/**
 * Returns the outermost element around a field that contains no other input,
 * i.e. the whole field row including label and country code selector.
 * @param {HTMLInputElement} input
 * @returns {HTMLElement}
 */
var getFieldRow = function getFieldRow(input) {
  var row = input;
  while (row.parentElement && row.parentElement.querySelectorAll('input').length === 1) {
    row = row.parentElement;
  }
  return row;
};

/**
 * @param {string} value - e.g. "+49 151 12345678"
 * @returns {string} e.g. "4915112345678"
 */
var getDigits = function getDigits(value) {
  return value.replace(/\D/g, '');
};

/**
 * Passes the number to a phone field of the form app as if it was pasted. Unlike typing, pasting a number
 * with another country code also switches the country selector of the field.
 * @param {HTMLInputElement} input
 * @param {string} value - e.g. "+43 6641234567"
 * @returns {boolean} Whether the form app took the number.
 */
var pastePhoneNumber = function pastePhoneNumber(input, value) {
  try {
    var clipboardData = new DataTransfer();
    clipboardData.setData('text/plain', value);
    var pasteEvent = new ClipboardEvent('paste', {
      clipboardData: clipboardData,
      // Firefox ignores clipboardData and takes the pasted text from its own dataType and data options only
      dataType: 'text/plain',
      data: value,
      bubbles: true,
      cancelable: true
    });

    // The form app cancels the paste event once it handles the number itself
    return !input.dispatchEvent(pasteEvent);
  } catch (error) {
    return false;
  }
};

/**
 * @param {ShadowRoot} root - Shadow root of the Shopify Forms embed.
 */
var initPhoneSync = function initPhoneSync(root) {
  // Address phone fields the customer phone was pasted into at least once
  var syncedPhones = new WeakSet();
  // Address phone fields the customer phone can't be passed to, left to the customer
  var failedPhones = new WeakSet();
  var syncTimeout;
  var getAddressPhones = function getAddressPhones() {
    return ADDRESS_PHONE_IDS.map(function (id) {
      return root.getElementById(id);
    }).filter(Boolean);
  };
  var toggleAddressPhones = function toggleAddressPhones() {
    // Without the customer phone there is nothing to pass on
    var hasCustomerPhone = !!root.getElementById(CUSTOMER_PHONE_ID);
    getAddressPhones().forEach(function (input) {
      getFieldRow(input).style.display = hasCustomerPhone && !failedPhones.has(input) ? 'none' : '';
    });
  };
  var syncAddressPhones = function syncAddressPhones() {
    var customerPhone = root.getElementById(CUSTOMER_PHONE_ID);
    if (!(customerPhone !== null && customerPhone !== void 0 && customerPhone.value)) return;
    getAddressPhones().forEach(function (addressPhone) {
      if (failedPhones.has(addressPhone)) return;

      // Pasted once even if the number already matches: unchecking "same as shipping" copies the shipping
      // phone into the billing address, but not its country. Afterwards whenever the number differs, e.g.
      // because selecting another country in the address also changes the country code of its phone.
      if (syncedPhones.has(addressPhone) && getDigits(addressPhone.value) === getDigits(customerPhone.value)) {
        return;
      }
      syncedPhones.add(addressPhone);
      if (!pastePhoneNumber(addressPhone, customerPhone.value)) {
        failedPhones.add(addressPhone);
        toggleAddressPhones();
      }
    });
  };

  // Changing the country updates the number only after the next paint
  var scheduleSync = function scheduleSync() {
    clearTimeout(syncTimeout);
    syncTimeout = setTimeout(syncAddressPhones, 150);
  };
  var onCustomerPhoneChange = function onCustomerPhoneChange(event) {
    if (event.target.id === CUSTOMER_PHONE_ID) scheduleSync();
  };

  // Address fields are rendered later (e.g. billing address once "same as shipping" is unchecked),
  // a country change only swaps the flag of the selector
  new MutationObserver(function () {
    toggleAddressPhones();
    scheduleSync();
  }).observe(root, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['src']
  });
  root.addEventListener('input', onCustomerPhoneChange);
  root.addEventListener('paste', onCustomerPhoneChange);
  // Runs before the submit handler of the form app, in case the customer submits right after typing
  root.addEventListener('submit', syncAddressPhones, true);
  toggleAddressPhones();
  scheduleSync();
};

// The app block renders an empty container, the forms app appends the <shopify-forms-embed> to it later
document.querySelectorAll('[data-form-root]').forEach(function (container) {
  var formId = (container.dataset.formsId || '').replace('forms-root-', '');
  if (!settings.enabled || !CUSTOMER_PHONE_ID || !FORM_IDS.includes(formId)) return;
  var initEmbed = function initEmbed() {
    var embed = container.querySelector('shopify-forms-embed');
    if (!(embed !== null && embed !== void 0 && embed.shadowRoot)) return false;
    initPhoneSync(embed.shadowRoot);
    return true;
  };
  if (initEmbed()) return;
  var observer = new MutationObserver(function () {
    if (initEmbed()) observer.disconnect();
  });
  observer.observe(container, {
    childList: true
  });
});

/***/ }),

/***/ "./src/js/modules/ed-gift-system-drawer.js":
/*!*************************************************!*\
  !*** ./src/js/modules/ed-gift-system-drawer.js ***!
  \*************************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var GiftSystemDrawer = /*#__PURE__*/function (_HTMLElement) {
  function GiftSystemDrawer() {
    var _this;
    _classCallCheck(this, GiftSystemDrawer);
    _this = _callSuper(this, GiftSystemDrawer);
    _this.cartType = document.body.getAttribute('data-cart-type');
    _this._attachListeners();
    return _this;
  }
  _inherits(GiftSystemDrawer, _HTMLElement);
  return _createClass(GiftSystemDrawer, [{
    key: "_attachListeners",
    value: function _attachListeners() {
      this.addEventListener('submit', this.onSubmit.bind(this));
      document.addEventListener('ed:gift-cart-updated', this.onGiftCartUpdated.bind(this));
    }
  }, {
    key: "getSectionsToUpdate",
    value: function getSectionsToUpdate() {
      var sections = new Set();
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && cartDrawer.dataset.sectionId) {
        sections.add(cartDrawer.dataset.sectionId);
      }
      var cartItemsComponents = document.querySelectorAll('cart-items-component');
      cartItemsComponents.forEach(function (item) {
        if (item instanceof HTMLElement && item.dataset.sectionId) {
          sections.add(item.dataset.sectionId);
        }
      });
      return Array.from(sections).join(',');
    }
  }, {
    key: "onGiftCartUpdated",
    value: function onGiftCartUpdated(event) {
      var _event$detail = event.detail,
        success = _event$detail.success,
        data = _event$detail.data,
        error = _event$detail.error;
      if (!success) {
        console.error('Gift cart update failed:', error);
        this.error = true;
        return;
      }
      if (this.cartType == 'page') {
        window.location = '/cart';
        return;
      }
      document.dispatchEvent(new CustomEvent('ed:handle-cart-drawer', {
        detail: {
          isCustomAtcButton: true
        }
      }));
      this.error = false;
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (cart && cart.classList.contains('is-empty')) {
        cart.classList.remove('is-empty');
      }
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(event) {
      event.preventDefault();
      var form = event.target;
      var button = form.querySelector('.btn-add-gift-to-cart-drawer');
      if (button) {
        button.setAttribute('disabled', 'true');
      }
      var formData = new FormData(form);
      if (this.cartType != 'page') {
        formData.append('sections', this.getSectionsToUpdate());
        formData.append('sections_url', window.location.pathname);
        formData.append('properties[_free-gift]', 'true');
        formData.append('properties[_do_not_delete]', 'true');
      }
      document.dispatchEvent(new CustomEvent('ed:gift-add-to-cart', {
        detail: {
          formData: formData,
          cartType: this.cartType,
          sections: this.getSectionsToUpdate()
        }
      }));
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-gift-system-drawer')) {
  customElements.define('ed-gift-system-drawer', GiftSystemDrawer);
}

/***/ }),

/***/ "./src/js/modules/ed-gift-system.js":
/*!******************************************!*\
  !*** ./src/js/modules/ed-gift-system.js ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _helpers_events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/events */ "./src/js/helpers/events.js");
/* harmony import */ var _theme_section_renderer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @theme/section-renderer */ "./assets/section-renderer.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }


var GiftSystemMain = /*#__PURE__*/function (_HTMLElement) {
  function GiftSystemMain() {
    _classCallCheck(this, GiftSystemMain);
    return _callSuper(this, GiftSystemMain);
  }
  _inherits(GiftSystemMain, _HTMLElement);
  return _createClass(GiftSystemMain);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-gift-system-main')) {
  customElements.define('ed-gift-system-main', GiftSystemMain);
}
var GiftItem = /*#__PURE__*/function (_HTMLElement2) {
  function GiftItem() {
    var _this;
    _classCallCheck(this, GiftItem);
    _this = _callSuper(this, GiftItem);
    _defineProperty(_this, "handleCartUpdate", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
        var _event$detail$data;
        var sections, response, cart;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(event.target === _this)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              sections = (_event$detail$data = event.detail.data) === null || _event$detail$data === void 0 ? void 0 : _event$detail$data.sections;
              if (sections) {
                Object.entries(sections).forEach(function (_ref2) {
                  var _ref3 = _slicedToArray(_ref2, 2),
                    sectionId = _ref3[0],
                    html = _ref3[1];
                  (0,_theme_section_renderer__WEBPACK_IMPORTED_MODULE_1__.morphSection)(sectionId, html);
                });
              }
              _context.n = 2;
              return fetch('/cart.js');
            case 2:
              response = _context.v;
              _context.n = 3;
              return response.json();
            case 3:
              cart = _context.v;
              _this.updateGiftLogic(cart);
            case 4:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _this.giftEnabled = _this.getAttribute('gift-enabled') || 'false';
    _this.alreadyInCart = _this.getAttribute('already-in-cart') || 'false';
    _this.multipleEnabled = _this.getAttribute('multiple-enabled') === 'true';
    _this.priceTarget = _this.getAttribute('price-target');
    _this.cartTotalPrice = parseInt(_this.getAttribute('cart-total'), 10) || 0;
    _this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    _this.cartType = document.body.getAttribute('data-cart-type');
    _this.giftForm = document.querySelector('form.popup-product-atc-page-gift');
    _this.toCartBtnPage = _this.querySelector('.page-btn-gift-to-cart');
    _this.oneGiftLimitEnabled = _this.getAttribute('data-one-gift-limit-enabled');
    _this.level = parseInt(_this.getAttribute('index'), 10);
    _this._attachSelectors();
    _this._attachListeners();
    document.addEventListener(_helpers_events__WEBPACK_IMPORTED_MODULE_0__.ThemeEvents.cartUpdate, _this.handleCartUpdate.bind(_this));
    document.addEventListener('ed:gift-cart-updated', _this.onGiftCartUpdated.bind(_this));
    if (_this.getAttribute('remove-gift')) {
      _this.removeGiftFromCart();
    }
    if (_this.autoAdd === 'true' && _this.multipleSelectLimit <= 1) {
      setTimeout(function () {
        if (this.checkMultipleAutoAdds()) {
          if (this === this.eligibleAutoFreeGifts[0]) {
            this.addMultipleAutoGifts(this.eligibleAutoFreeGifts);
          }
        } else {
          this.checkAutoAdd();
        }
      }.bind(_this), 50);
    }
    return _this;
  }
  _inherits(GiftItem, _HTMLElement2);
  return _createClass(GiftItem, [{
    key: "autoAdd",
    get: function get() {
      return this.getAttribute('auto-add');
    }
  }, {
    key: "variantId",
    get: function get() {
      return this.getAttribute('variant-id');
    }
  }, {
    key: "giftEnabled",
    get: function get() {
      return this.getAttribute('gift-enabled');
    },
    set: function set(value) {
      this.setAttribute('gift-enabled', value);
    }
  }, {
    key: "alreadyInCart",
    get: function get() {
      return this.getAttribute('already-in-cart');
    },
    set: function set(value) {
      this.setAttribute('already-in-cart', value);
    }
  }, {
    key: "multipleSelectLimit",
    get: function get() {
      var limit = parseInt(this.getAttribute('data-multiple-select-limit'), 10);
      return isNaN(limit) || limit < 1 ? 1 : limit;
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.popupButton = this.querySelector('.btn-container .btn-open-popup');
      this.button = this.querySelector('.btn-container button');
      this.popupComponent = this.querySelector('.ed-gift-item-popup');
      this.cartType = document.body.getAttribute('data-cart-type');
      this.form = document.querySelector('#cart-form');
      this.cart = document.querySelector('.cart-drawer') || document.querySelector('cart-notification');
      this.drawerButton = this.querySelector('.btn-container .btn-add-gift-to-cart-drawer');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      if (this.cartType === 'drawer' && this.giftEnabled === 'true' && this.alreadyInCart === 'false' && this.popupButton) {
        this.popupButton.addEventListener('click', this.onButtonClick.bind(this));
      }
      if (this.giftEnabled === 'true' && this.alreadyInCart === 'false' && this.button) {
        this.button.addEventListener('click', this.onButtonClick.bind(this));
        if (this.giftForm) {
          this.giftForm.addEventListener('submit', this.onSubmitDrawerGift.bind(this));
        }
      }
      if (this.oneGiftLimitEnabled === 'true') {
        this.changeAvailabilityStatusForOneGiftLimit();
      }
    }
  }, {
    key: "_removeListeners",
    value: function _removeListeners() {
      document.removeEventListener('click', this.onButtonClick.bind(this));
    }
  }, {
    key: "changeAvailabilityStatusForOneGiftLimit",
    value: function changeAvailabilityStatusForOneGiftLimit() {
      var _this2 = this;
      var highestLevelReached = 0;
      var giftItems = document.querySelectorAll('ed-gift-item');
      giftItems.forEach(function (item) {
        var giftLevel = parseInt(item.getAttribute('index'), 10);
        var priceTarget = parseFloat(item.getAttribute('price-target'));
        if (_this2.cartTotalPrice >= priceTarget && giftLevel > highestLevelReached) {
          highestLevelReached = giftLevel;
        }
      });
      this.giftEnabled = this.level === highestLevelReached;
      var giftsInCart = this.getGiftsInCart();
      if (giftsInCart.length > 1) {
        this.removeGiftFromCart(giftsInCart[0]);
      }
    }
  }, {
    key: "getGiftsInCart",
    value: function getGiftsInCart() {
      var giftsInCart = [];
      var giftItems = document.querySelectorAll('ed-gift-item');
      giftItems.forEach(function (item) {
        var alreadyInCart = item.getAttribute('already-in-cart') === 'true' || item.getAttribute('already-in-cart-drawer') === 'true';
        if (alreadyInCart) {
          var id = item.getAttribute('already-in-cart-variant') || item.getAttribute('variant-id');
          giftsInCart.push(id);
        }
      });
      giftsInCart = _toConsumableArray(new Set(giftsInCart));
      return giftsInCart;
    }
  }, {
    key: "onButtonClick",
    value: function onButtonClick() {
      if (this.multipleEnabled) {
        this.openPopup();
      } else {
        this.addGiftToCart();
      }
    }
  }, {
    key: "detectMilestoneReached",
    value: function detectMilestoneReached() {
      if (this.cartTotalPrice >= this.priceTarget) {
        this.giftEnabled = true;
        if (this.drawerButton) {
          this.drawerButton.removeAttribute('disabled');
        }
      } else {
        this.giftEnabled = false;
        if (this.drawerButton) {
          this.drawerButton.setAttribute('disabled', 'true');
        }
      }
    }
  }, {
    key: "detectAlreadyInCart",
    value: function detectAlreadyInCart(cart) {
      var _this3 = this;
      if (!this.multipleEnabled) {
        var itemFound = false;
        cart.items.forEach(function (item) {
          var variantId = item.variant_id.toString();
          if (itemFound === true) {
            return;
          }
          if (_this3.variantId === variantId) {
            itemFound = true;
            _this3.alreadyInCart = true;
          } else {
            _this3.alreadyInCart = false;
          }
        });
      } else {
        var giftIds = this.getAttribute('variant-ids').split(',').map(function (id) {
          return id.trim();
        });
        var foundVariants = [];
        cart.items.forEach(function (item) {
          var variantId = item.variant_id.toString();
          if (giftIds.includes(variantId)) {
            foundVariants.push(variantId);
          }
        });
        foundVariants = _toConsumableArray(new Set(foundVariants));
        if (foundVariants.length >= this.multipleSelectLimit) {
          this.alreadyInCart = true;
          this.setAttribute('found-gift-variants', foundVariants.join(','));
        } else {
          this.alreadyInCart = false;
          if (foundVariants.length > 0) {
            this.setAttribute('found-gift-variants', foundVariants.join(','));
          } else {
            this.removeAttribute('found-gift-variants');
          }
        }
      }
    }
  }, {
    key: "checkAutoAdd",
    value: function checkAutoAdd() {
      if (this.giftEnabled === 'true' && this.alreadyInCart === 'false') {
        this.addGiftToCart();
      }
    }
  }, {
    key: "checkMultipleAutoAdds",
    value: function checkMultipleAutoAdds() {
      this.eligibleAutoFreeGifts = document.querySelectorAll('ed-gift-system-main ed-gift-item[already-in-cart="false"][gift-enabled="true"]');
      return this.eligibleAutoFreeGifts.length >= 2;
    }
  }, {
    key: "getSectionsToUpdate",
    value: function getSectionsToUpdate() {
      var sections = new Set();
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && cartDrawer.dataset.sectionId) {
        sections.add(cartDrawer.dataset.sectionId);
      }
      var cartItemsComponents = document.querySelectorAll('cart-items-component');
      cartItemsComponents.forEach(function (item) {
        if (item instanceof HTMLElement && item.dataset.sectionId) {
          sections.add(item.dataset.sectionId);
        }
      });
      return Array.from(sections).join(',');
    }
  }, {
    key: "onGiftCartUpdated",
    value: function onGiftCartUpdated(event) {
      var _this4 = this;
      var _event$detail = event.detail,
        success = _event$detail.success,
        data = _event$detail.data,
        error = _event$detail.error;
      if (!success) {
        console.error('Gift cart update failed:', error);
        this.error = true;
        return;
      }
      if (data && data.items) {
        this.justAddedGift = true;
        this.updateGiftLogic(data);
        setTimeout(function () {
          _this4.justAddedGift = false;
        }, 1000);
      }
      if (this.dataset.cartType == 'page') {
        window.location = '/cart';
        return;
      }
      document.dispatchEvent(new CustomEvent('ed:handle-cart-drawer', {
        detail: {
          isCustomAtcButton: true
        }
      }));
      this.error = false;
      if (this.cart && this.cart.classList.contains('is-empty')) {
        this.cart.classList.remove('is-empty');
      }
      this.detectMilestoneReached();
    }
  }, {
    key: "updateGiftLogic",
    value: function updateGiftLogic(cart) {
      var _this5 = this;
      if (cart.total_price !== undefined) {
        this.cartTotalPrice = cart.total_price || 0;
        cart.items.forEach(function (item) {
          if (item.requires_shipping === false) {
            _this5.cartTotalPrice = _this5.cartTotalPrice - (item.final_line_price || 0);
            return;
          }

          // Use data-key (unique per cart line) to avoid false positives when a product
          // has both a gift variant and a normal variant sharing the same product_id
          var itemElement = document.querySelector(".ed-cart-item[data-key=\"".concat(item.key, "\"]"));
          if (itemElement) {
            var isExcludedFromProgressBar = itemElement.dataset.excludeGwp === 'true';
            if (isExcludedFromProgressBar) {
              _this5.cartTotalPrice = _this5.cartTotalPrice - (item.final_line_price || 0);
            }
          }
        });
        if (isNaN(this.cartTotalPrice)) {
          this.cartTotalPrice = cart.total_price || 0;
        }
      }
      this.detectMilestoneReached();
      this.detectAlreadyInCart(cart);
      if (this.autoAdd === 'true' && this.multipleSelectLimit <= 1) {
        setTimeout(function () {
          if (this.checkMultipleAutoAdds()) {
            if (this === this.eligibleAutoFreeGifts[0]) {
              this.addMultipleAutoGifts(this.eligibleAutoFreeGifts);
            }
          } else {
            this.checkAutoAdd();
          }
        }.bind(this), 50);
      }
      var foundVariants = this.getAttribute('found-gift-variants');
      var foundCount = foundVariants ? foundVariants.split(',').length : 0;
      var rawCartTotal = cart.total_price || 0;
      var milestoneReached = this.cartTotalPrice >= this.priceTarget;
      if (this.justAddedGift) {
        return;
      }
      if (this.cartTotalPrice === 0 && rawCartTotal > 0) {
        return;
      }
      if (foundCount > 0 && !milestoneReached) {
        this.removeGiftFromCart();
      }
      if (this.oneGiftLimitEnabled === 'true') {
        this.changeAvailabilityStatusForOneGiftLimit();
      }
      if (this.alreadyInCart === 'false' && this.giftEnabled === 'true') {
        this._attachListeners();
      } else {
        this._removeListeners();
      }
    }
  }, {
    key: "onSubmitDrawerGift",
    value: function onSubmitDrawerGift(event) {
      event.preventDefault();
      if (this.cartType === 'page') {
        this.cart = document.querySelector('cart-notification');
      }
      var formData = new FormData(this.giftForm);
      if (this.dataset.cartType != 'page') {
        formData.append('sections', this.getSectionsToUpdate());
        formData.append('sections_url', window.location.pathname);
        formData.append('properties[_free-gift]', 'true');
      }
      document.dispatchEvent(new CustomEvent('ed:gift-add-to-cart', {
        detail: {
          formData: formData,
          cartType: this.cartType,
          sections: this.getSectionsToUpdate()
        }
      }));
    }
  }, {
    key: "addGiftToCart",
    value: function addGiftToCart() {
      if (this.toCartBtnPage) {
        this.toCartBtnPage.setAttribute('disabled', 'true');
      }
      if (this.cartType !== 'drawer') {
        fetch("/cart/add.js", {
          body: JSON.stringify({
            id: this.variantId,
            quantity: 1,
            properties: {
              '_free-gift': true
            }
          }),
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        }).then(function () {
          location.reload();
        })["catch"](function (e) {
          console.error(e);
        });
      }
    }
  }, {
    key: "addMultipleAutoGifts",
    value: function addMultipleAutoGifts(freeGiftItems) {
      var items = [];
      freeGiftItems.forEach(function (freeGift) {
        var item = {
          id: freeGift.getAttribute('variant-id'),
          quantity: 1,
          properties: {
            '_free-gift': true
          }
        };
        items.push(item);
      });
      var formData = {
        'items': items
      };
      fetch("/cart/add.js", {
        body: JSON.stringify(formData),
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(function () {
        location.reload();
      })["catch"](function (e) {
        console.error(e);
      });
    }
  }, {
    key: "removeGiftFromCart",
    value: function removeGiftFromCart(removeLowerLevelGiftVariantId) {
      var _this6 = this;
      if (this.cartType === 'drawer') {
        var variantsToRemove = [];
        if (this.multipleEnabled && this.alreadyInCart === 'true') {
          var foundVariants = this.getAttribute('found-gift-variants');
          if (foundVariants) {
            variantsToRemove = foundVariants.split(',');
          } else {
            // Fallback to the Liquid-provided list
            var alreadyInCartVariant = this.getAttribute('already-in-cart-variant');
            if (alreadyInCartVariant) {
              variantsToRemove = alreadyInCartVariant.split(',');
            }
          }
        } else {
          variantsToRemove = [this.variantId];
        }
        if (removeLowerLevelGiftVariantId) {
          variantsToRemove = [removeLowerLevelGiftVariantId];
        }
        if (!this.form) {
          console.error('Cart form not found');
          return;
        }
        variantsToRemove.forEach(function (variantId) {
          if (!variantId) {
            return;
          }
          var formData = new FormData(_this6.form);
          formData.append('sections', _this6.getSectionsToUpdate());
          formData.append('sections_url', window.location.pathname);
          formData.append('id', variantId.trim());
          formData.append('quantity', '0');
          document.dispatchEvent(new CustomEvent('ed:gift-remove-from-cart', {
            detail: {
              formData: formData,
              variantId: variantId.trim(),
              cartType: _this6.cartType,
              sections: _this6.getSectionsToUpdate()
            }
          }));
        });
      } else {
        var _variantsToRemove = [];
        if (this.multipleEnabled && this.alreadyInCart === 'true') {
          var _foundVariants = this.getAttribute('found-gift-variants');
          if (_foundVariants) {
            _variantsToRemove = _foundVariants.split(',');
          } else {
            // Fallback to the Liquid-provided list
            var _alreadyInCartVariant = this.getAttribute('already-in-cart-variant');
            if (_alreadyInCartVariant) {
              _variantsToRemove = _alreadyInCartVariant.split(',');
            }
          }
        } else {
          _variantsToRemove = [this.variantId];
        }
        if (removeLowerLevelGiftVariantId) {
          _variantsToRemove = [removeLowerLevelGiftVariantId];
        }
        var removePromises = _variantsToRemove.filter(function (variantId) {
          return variantId;
        }).map(function (variantId) {
          return fetch('/cart/change.js', {
            body: JSON.stringify({
              id: variantId.trim(),
              quantity: 0
            }),
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            }
          });
        });
        Promise.all(removePromises).then(function () {
          location.reload();
        })["catch"](function (e) {
          console.error(e);
          location.reload();
        });
      }
    }
  }, {
    key: "openPopup",
    value: function openPopup() {
      var cartDialog = document.querySelector('cart-drawer-component dialog.cart-drawer__dialog');
      var appendTarget = cartDialog || document.body;
      this.popupComponent.setAttribute('data-multiple-select-limit', this.multipleSelectLimit);
      appendTarget.appendChild(this.popupComponent);
      this.popupComponent.setAttribute('open', 'true');
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-gift-item')) {
  customElements.define('ed-gift-item', GiftItem);
}
var GiftItemSelectPopup = /*#__PURE__*/function (_HTMLElement3) {
  function GiftItemSelectPopup() {
    var _this7;
    _classCallCheck(this, GiftItemSelectPopup);
    _this7 = _callSuper(this, GiftItemSelectPopup);
    _this7.btnClose = _this7.querySelector('.btn-close');
    _this7.selectedProducts = new Set();
    _this7._attachSelectors();
    _this7._attachListeners();
    _this7._createCounter();
    return _this7;
  }
  _inherits(GiftItemSelectPopup, _HTMLElement3);
  return _createClass(GiftItemSelectPopup, [{
    key: "open",
    get: function get() {
      return this.getAttribute('open');
    },
    set: function set(value) {
      this.setAttribute('open', value);
    }
  }, {
    key: "multipleSelectLimit",
    get: function get() {
      var limit = parseInt(this.getAttribute('data-multiple-select-limit'), 10);
      return isNaN(limit) || limit < 1 ? 1 : limit;
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.cartType = document.body.getAttribute('data-cart-type');
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      this.forms = this.querySelectorAll('form.popup-product-atc');
      this.buttons = this.querySelectorAll('button[type="submit"]');
      this.confirmButton = this.querySelector('.confirm-gift-button');
    }
  }, {
    key: "_createCounter",
    value: function _createCounter() {
      if (this.multipleSelectLimit > 1) {
        var existingCounter = this.querySelector('.gift-selection-counter');
        if (existingCounter) {
          existingCounter.remove();
        }
        var counter = document.createElement('div');
        counter.className = 'gift-selection-counter';
        counter.innerHTML = "<span class=\"counter-text\">".concat(this.selectedProducts.size, " of ").concat(this.multipleSelectLimit, " gifts selected</span>");
        var modalContent = this.querySelector('.modal-content');
        if (modalContent) {
          modalContent.insertBefore(counter, modalContent.firstChild);
        }
      }
    }
  }, {
    key: "_updateCounter",
    value: function _updateCounter() {
      var counter = this.querySelector('.gift-selection-counter .counter-text');
      if (counter) {
        counter.textContent = "".concat(this.selectedProducts.size, " of ").concat(this.multipleSelectLimit, " gifts selected");
      }
      this._updateConfirmButton();
    }
  }, {
    key: "_updateConfirmButton",
    value: function _updateConfirmButton() {
      if (this.confirmButton) {
        if (this.multipleSelectLimit > 1) {
          this.confirmButton.disabled = this.selectedProducts.size !== this.multipleSelectLimit;
        } else {
          this.confirmButton.disabled = this.selectedProducts.size === 0;
        }
      }
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this8 = this;
      document.addEventListener('keydown', this.closeOnEsc.bind(this));
      this.btnClose.addEventListener('click', this.closeModal.bind(this));
      this.forms.forEach(function (form) {
        form.submitButton = form.querySelector('button[type="submit"]');
        form.addEventListener('submit', _this8.onSubmit.bind(_this8));
      });
      this.addEventListener('click', function (e) {
        if (e.target.matches('.gift-select-radio')) {
          _this8.handleRadioClick(e);
        } else if (e.target.closest('.item-container')) {
          _this8.handleContainerClick(e);
        }
      });
      if (this.confirmButton) {
        this.confirmButton.addEventListener('click', function (e) {
          e.preventDefault();
          _this8.handleConfirmClick();
        });
      }
      document.addEventListener('ed:gift-cart-updated', this.onGiftCartUpdated.bind(this));
    }
  }, {
    key: "handleConfirmClick",
    value: function handleConfirmClick() {
      if (this.multipleSelectLimit > 1) {
        this.submitMultipleGifts();
      } else {
        var allRadios = this.querySelectorAll('.gift-select-radio');
        var activeRadio = Array.from(allRadios).find(function (rb) {
          return rb.checked;
        });
        if (activeRadio) {
          var form = activeRadio.closest('form');
          if (form) {
            var syntheticEvent = new Event('submit', {
              cancelable: true,
              bubbles: true
            });
            Object.defineProperty(syntheticEvent, 'currentTarget', {
              value: form
            });
            this.onSubmit(syntheticEvent);
          }
        }
      }
    }
  }, {
    key: "submitMultipleGifts",
    value: function submitMultipleGifts() {
      var _this9 = this;
      if (this.selectedProducts.size !== this.multipleSelectLimit) {
        return;
      }
      this.confirmButton.setAttribute('disabled', 'true');
      var items = [];
      this.selectedProducts.forEach(function (variantId) {
        var form = _this9.querySelector("form input[name=\"id\"][value=\"".concat(variantId, "\"]")).closest('form');
        var properties = {};
        form.querySelectorAll('input[name^="properties"]').forEach(function (input) {
          var match = input.name.match(/properties\[(.+)\]/);
          if (match) {
            properties[match[1]] = input.value;
          }
        });
        properties['_free-gift'] = 'true';
        items.push({
          id: variantId,
          quantity: 1,
          properties: properties
        });
      });
      if (this.dataset.cartType === 'page') {
        fetch("/cart/add.js", {
          body: JSON.stringify({
            items: items
          }),
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        }).then(function () {
          location.reload();
        })["catch"](function (e) {
          console.error(e);
          _this9.confirmButton.removeAttribute('disabled');
        });
      } else {
        document.dispatchEvent(new CustomEvent('ed:gift-add-multiple-to-cart', {
          detail: {
            items: items,
            cartType: this.cartType,
            sections: this.getSectionsToUpdate()
          }
        }));
      }
    }
  }, {
    key: "handleRadioClick",
    value: function handleRadioClick(e) {
      var variantId = e.target.closest('form').querySelector('input[name="id"]').value;
      if (this.multipleSelectLimit > 1) {
        if (e.target.checked && this.selectedProducts.has(variantId)) {
          e.target.checked = false;
          this.selectedProducts["delete"](variantId);
        } else if (e.target.checked && this.selectedProducts.size < this.multipleSelectLimit) {
          this.selectedProducts.add(variantId);
        } else if (e.target.checked && this.selectedProducts.size >= this.multipleSelectLimit) {
          e.target.checked = false;
        }
        this._updateCounter();
      } else {
        var allRadios = this.querySelectorAll('.gift-select-radio');
        allRadios.forEach(function (rb) {
          return rb.checked = false;
        });
        e.target.checked = true;
        this.selectedProducts.clear();
        this.selectedProducts.add(variantId);
        this._updateCounter();
      }
    }
  }, {
    key: "handleContainerClick",
    value: function handleContainerClick(e) {
      var container = e.target.closest('.item-container');
      var radio = container.querySelector('.gift-select-radio');
      if (radio) {
        radio.click();
      }
    }
  }, {
    key: "getSectionsToUpdate",
    value: function getSectionsToUpdate() {
      var sections = new Set();
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && cartDrawer.dataset.sectionId) {
        sections.add(cartDrawer.dataset.sectionId);
      }
      var cartItemsComponents = document.querySelectorAll('cart-items-component');
      cartItemsComponents.forEach(function (item) {
        if (item instanceof HTMLElement && item.dataset.sectionId) {
          sections.add(item.dataset.sectionId);
        }
      });
      return Array.from(sections).join(',');
    }
  }, {
    key: "onGiftCartUpdated",
    value: function onGiftCartUpdated(event) {
      var _event$detail2 = event.detail,
        success = _event$detail2.success,
        data = _event$detail2.data,
        error = _event$detail2.error;
      if (!success) {
        console.error('Gift cart update failed:', error);
        this.error = true;
        return;
      }
      if (this.dataset.cartType == 'page') {
        window.location = '/cart';
        return;
      }
      document.dispatchEvent(new CustomEvent('ed:handle-cart-drawer', {
        detail: {
          isCustomAtcButton: true
        }
      }));
      this.error = false;
      if (this.cart && this.cart.classList.contains('is-empty')) {
        this.cart.classList.remove('is-empty');
      }
      this.btnClose.click();
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(event) {
      event.preventDefault();
      this.buttons.forEach(function (btn) {
        return btn.setAttribute('disabled', 'true');
      });
      var form = event.currentTarget;
      var formData = new FormData(form);
      if (this.dataset.cartType != 'page') {
        formData.append('sections', this.getSectionsToUpdate());
        formData.append('sections_url', window.location.pathname);
        formData.append('properties[_free-gift]', 'true');
      }
      document.dispatchEvent(new CustomEvent('ed:gift-add-to-cart', {
        detail: {
          formData: formData,
          cartType: this.cartType,
          sections: this.getSectionsToUpdate()
        }
      }));
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.open = false;
    }
  }, {
    key: "closeOnEsc",
    value: function closeOnEsc(e) {
      if (e.key === 'Escape') {
        this.open = false;
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-gift-item-select-popup')) {
  customElements.define('ed-gift-item-select-popup', GiftItemSelectPopup);
}
var GiftItemSelectPopupItem = /*#__PURE__*/function (_HTMLElement4) {
  function GiftItemSelectPopupItem() {
    var _this0;
    _classCallCheck(this, GiftItemSelectPopupItem);
    _this0 = _callSuper(this, GiftItemSelectPopupItem);
    _this0.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    _this0.btnClose = document.querySelector('.ed-gift-item-popup .btn-close');
    _this0.btnAddToCart = _this0.querySelector('.btn-container .page-button');
    _this0.atcButtons = document.querySelectorAll('.btn-container .page-button');
    _this0.btnAddToCartDrawer = _this0.querySelector('.btn-container .drawer-button');
    _this0.cartType = document.body.getAttribute('data-cart-type');
    _this0.forms = document.querySelectorAll('form.popup-product-atc-page');
    _this0._attachListeners();
    return _this0;
  }
  _inherits(GiftItemSelectPopupItem, _HTMLElement4);
  return _createClass(GiftItemSelectPopupItem, [{
    key: "productId",
    get: function get() {
      return this.getAttribute('product-id');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this1 = this;
      if (this.btnAddToCart) {
        this.btnAddToCart.addEventListener('click', this.addGiftToCart.bind(this));
      }
      if (this.forms) {
        this.forms.forEach(function (form) {
          form.addEventListener('submit', _this1.onSubmitDrawer.bind(_this1));
        });
      }
      document.addEventListener('ed:gift-cart-updated', this.onGiftCartUpdated.bind(this));
    }
  }, {
    key: "getSectionsToUpdate",
    value: function getSectionsToUpdate() {
      var sections = new Set();
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && cartDrawer.dataset.sectionId) {
        sections.add(cartDrawer.dataset.sectionId);
      }
      var cartItemsComponents = document.querySelectorAll('cart-items-component');
      cartItemsComponents.forEach(function (item) {
        if (item instanceof HTMLElement && item.dataset.sectionId) {
          sections.add(item.dataset.sectionId);
        }
      });
      return Array.from(sections).join(',');
    }
  }, {
    key: "onGiftCartUpdated",
    value: function onGiftCartUpdated(event) {
      var _event$detail3 = event.detail,
        success = _event$detail3.success,
        data = _event$detail3.data,
        error = _event$detail3.error;
      if (!success) {
        console.error('Gift cart update failed:', error);
        this.error = true;
        return;
      }
      if (this.dataset.cartType == 'page') {
        window.location = '/cart';
        return;
      }
      document.dispatchEvent(new CustomEvent('ed:handle-cart-drawer', {
        detail: {
          isCustomAtcButton: true
        }
      }));
      this.error = false;
      if (this.cart && this.cart.classList.contains('is-empty')) {
        this.cart.classList.remove('is-empty');
      }
      this.btnClose.click();
    }
  }, {
    key: "onSubmitDrawer",
    value: function onSubmitDrawer(event) {
      event.preventDefault();
      var form = event.currentTarget;
      var formVariantId = form.querySelector('input[type="hidden"][name="id"]').value;
      if (this.productId === formVariantId) {
        if (this.cartType === 'page') {
          this.cart = document.querySelector('cart-notification');
        }
        var formData = new FormData(form);
        if (this.dataset.cartType != 'page') {
          formData.append('sections', this.getSectionsToUpdate());
          formData.append('sections_url', window.location.pathname);
          formData.append('properties[_free-gift]', 'true');
        }
        document.dispatchEvent(new CustomEvent('ed:gift-add-to-cart', {
          detail: {
            formData: formData,
            cartType: this.cartType,
            sections: this.getSectionsToUpdate()
          }
        }));
      }
    }
  }, {
    key: "addGiftToCart",
    value: function addGiftToCart() {
      this.atcButtons.forEach(function (btn) {
        return btn.setAttribute('disabled', 'true');
      });
      fetch("/cart/add.js", {
        body: JSON.stringify({
          id: this.productId,
          quantity: 1,
          properties: {
            '_free-gift': true
          }
        }),
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(function () {
        location.reload();
      })["catch"](function (e) {
        console.error(e);
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-gift-item-select-popup-item')) {
  customElements.define('ed-gift-item-select-popup-item', GiftItemSelectPopupItem);
}
var GiftSystemProgressBar = /*#__PURE__*/function (_HTMLElement5) {
  function GiftSystemProgressBar() {
    var _this10;
    _classCallCheck(this, GiftSystemProgressBar);
    _this10 = _callSuper(this, GiftSystemProgressBar);
    _defineProperty(_this10, "handleCartUpdate", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(event) {
        var response, cart;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return fetch('/cart.js');
            case 1:
              response = _context2.v;
              _context2.n = 2;
              return response.json();
            case 2:
              cart = _context2.v;
              _this10.updateProgressBar(cart);
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref4.apply(this, arguments);
      };
    }());
    _defineProperty(_this10, "onGiftCartUpdated", function (event) {
      var _event$detail4 = event.detail,
        success = _event$detail4.success,
        data = _event$detail4.data;
      if (success && data && data.items) {
        _this10.updateProgressBar(data);
      }
    });
    _this10.cartTotalPrice = parseInt(_this10.getAttribute('cart-total'));
    _this10.missingAmount = _this10.querySelectorAll('.text-container .missing-amount-text .value');
    _this10.handleProgressBars();
    document.addEventListener(_helpers_events__WEBPACK_IMPORTED_MODULE_0__.ThemeEvents.cartUpdate, _this10.handleCartUpdate.bind(_this10));
    document.addEventListener('ed:gift-cart-updated', _this10.handleCartUpdate.bind(_this10));
    document.addEventListener('ed:gift-cart-updated', _this10.onGiftCartUpdated.bind(_this10));
    return _this10;
  }
  _inherits(GiftSystemProgressBar, _HTMLElement5);
  return _createClass(GiftSystemProgressBar, [{
    key: "updateProgressBar",
    value: function updateProgressBar(cart) {
      var _this11 = this;
      this.cartTotalPrice = cart.total_price;
      cart.items.forEach(function (item) {
        if (item.requires_shipping === false) {
          _this11.cartTotalPrice = _this11.cartTotalPrice - item.final_line_price;
          return;
        }

        // Use data-key (unique per cart line) to avoid false positives when a product
        // has both a gift variant and a normal variant sharing the same product_id
        var itemElement = document.querySelector(".ed-cart-item[data-key=\"".concat(item.key, "\"]"));
        if (itemElement) {
          var isExcludedFromProgressBar = itemElement.dataset.excludeGwp === 'true';
          if (isExcludedFromProgressBar) {
            _this11.cartTotalPrice = _this11.cartTotalPrice - item.final_line_price;
          }
        }
      });
      this.handleProgressBars();
    }
  }, {
    key: "handleProgressBars",
    value: function handleProgressBars() {
      var milestones = this.querySelectorAll('ed-gift-system-progress-bar-item');
      var targetNotReached = false;
      for (var i = 0; i <= milestones.length - 1; i++) {
        var target = parseInt(milestones[i].getAttribute('target'));
        if (!targetNotReached) {
          this.calculateProgress(milestones[i], target);
          this.calculateMissingAmount(target);
        } else {
          milestones[i].firstElementChild.style.width = '0';
        }
        if (!this.checkMilestoneReached(target)) {
          targetNotReached = true;
          milestones[i].classList.remove('target-reached');
        } else {
          milestones[i].classList.add('target-reached');
        }
        if (i === milestones.length - 1 && this.checkMilestoneReached(target)) {
          this.setAttribute('all-milestones-reached', 'true');
        } else {
          this.removeAttribute('all-milestones-reached');
        }
      }
    }
  }, {
    key: "checkMilestoneReached",
    value: function checkMilestoneReached(target) {
      return this.cartTotalPrice >= target;
    }
  }, {
    key: "calculateProgress",
    value: function calculateProgress(progressBar, target) {
      var progress = Math.round(100 * this.cartTotalPrice / target);
      var progressElement = progressBar.querySelector('.current-progress');
      if (progress > 100) {
        progress = 100;
      }
      if (progressElement.style.width != progress) {
        progressElement.style.width = progress + '%';
      }
    }
  }, {
    key: "calculateMissingAmount",
    value: function calculateMissingAmount(target) {
      var _this12 = this;
      this.missingAmount.forEach(function (amount) {
        return amount.innerText = _this12.formatMoney(target - _this12.cartTotalPrice, window.edGiftSystemSettings.moneyFormat);
      });
    }
  }, {
    key: "formatMoney",
    value: function formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = format || '${{amount}}';
      function defaultTo(value, defaultValue) {
        return value == null || value !== value ? defaultValue : value;
      }
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultTo(precision, 2);
        thousands = defaultTo(thousands, ',');
        decimal = defaultTo(decimal, '.');
        if (isNaN(number) || number == null) {
          return 0;
        }
        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.'),
          dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          centsAmount = parts[1] ? decimal + parts[1] : '';
        return dollarsAmount + centsAmount;
      }
      var value = '';
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', '.');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, ',', '.');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
      }
      if (formatString.indexOf('with_comma_separator') !== -1) {
        return formatString.replace(placeholderRegex, value);
      } else {
        return formatString.replace(placeholderRegex, value);
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-gift-system-progress-bar')) {
  customElements.define('ed-gift-system-progress-bar', GiftSystemProgressBar);
}
var GiftSystemProgressBarItem = /*#__PURE__*/function (_HTMLElement6) {
  function GiftSystemProgressBarItem() {
    _classCallCheck(this, GiftSystemProgressBarItem);
    return _callSuper(this, GiftSystemProgressBarItem);
  }
  _inherits(GiftSystemProgressBarItem, _HTMLElement6);
  return _createClass(GiftSystemProgressBarItem);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-gift-system-progress-bar-item')) {
  customElements.define('ed-gift-system-progress-bar-item', GiftSystemProgressBarItem);
}

/***/ }),

/***/ "./src/js/modules/ed-pre-order-fields.js":
/*!***********************************************!*\
  !*** ./src/js/modules/ed-pre-order-fields.js ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _assets_events_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../assets/events.js */ "./assets/events.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


/**
 * Keeps the pre-order line item properties in sync with the selected variant.
 * The theme only morphs the add to cart button on a variant update, so the hidden
 * inputs inside the product form have to be swapped in separately.
 */
var EdPreOrderFields = /*#__PURE__*/function (_HTMLElement) {
  function EdPreOrderFields() {
    var _this;
    _classCallCheck(this, EdPreOrderFields);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, EdPreOrderFields, [].concat(args));
    /**
     * Replaces the hidden inputs with the ones rendered for the newly selected variant.
     * @param {VariantUpdateEvent} event - The variant update event.
     */
    _defineProperty(_this, "updatePreOrderFields", function (event) {
      if (event.detail.data.newProduct) {
        _this.dataset.productId = event.detail.data.newProduct.id;
      } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== _this.dataset.productId) {
        return;
      }
      var newPreOrderFields = event.detail.data.html.querySelector('ed-pre-order-fields');
      _this.innerHTML = newPreOrderFields ? newPreOrderFields.innerHTML : '';
    });
    return _this;
  }
  _inherits(EdPreOrderFields, _HTMLElement);
  return _createClass(EdPreOrderFields, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var closestSection = this.closest('.shopify-section, dialog');
      closestSection === null || closestSection === void 0 || closestSection.addEventListener(_assets_events_js__WEBPACK_IMPORTED_MODULE_0__.ThemeEvents.variantUpdate, this.updatePreOrderFields);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var closestSection = this.closest('.shopify-section, dialog');
      closestSection === null || closestSection === void 0 || closestSection.removeEventListener(_assets_events_js__WEBPACK_IMPORTED_MODULE_0__.ThemeEvents.variantUpdate, this.updatePreOrderFields);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-pre-order-fields')) {
  customElements.define('ed-pre-order-fields', EdPreOrderFields);
}

/***/ }),

/***/ "./src/js/modules/ed-rrp-price.js":
/*!****************************************!*\
  !*** ./src/js/modules/ed-rrp-price.js ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _helpers_events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/events */ "./src/js/helpers/events.js");
/* harmony import */ var _helpers_format_money__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helpers/format-money */ "./src/js/helpers/format-money.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }


var EdRrpPrice = /*#__PURE__*/function (_HTMLElement) {
  function EdRrpPrice() {
    _classCallCheck(this, EdRrpPrice);
    return _callSuper(this, EdRrpPrice, arguments);
  }
  _inherits(EdRrpPrice, _HTMLElement);
  return _createClass(EdRrpPrice, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
      this.updateRrp(parseInt(this.getAttribute('selected-variant')));
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.amountEl = this.querySelector('[data-amount]');
      this.dataScript = this.querySelector('script[type="application/json"]');
      if (this.dataScript) {
        this.rrpData = JSON.parse(this.dataScript.textContent);
      }
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      document.addEventListener(_helpers_events__WEBPACK_IMPORTED_MODULE_0__.ThemeEvents.variantUpdate, this.onVariantChange.bind(this));
    }
  }, {
    key: "onVariantChange",
    value: function onVariantChange(e) {
      var _e$detail;
      var variantId = (_e$detail = e.detail) === null || _e$detail === void 0 || (_e$detail = _e$detail.resource) === null || _e$detail === void 0 ? void 0 : _e$detail.id;
      this.updateRrp(variantId);
    }
  }, {
    key: "updateRrp",
    value: function updateRrp(id) {
      if (!this.rrpData || !this.amountEl) return;
      var value = this.rrpData[id];
      if (value && value.trim() !== '' && !value.includes('0.00') && !value.includes('0,00')) {
        this.amountEl.textContent = value;
        this.classList.remove('hidden');
      } else {
        this.amountEl.textContent = ''; // oder z.B. "—"
        this.classList.add('hidden');
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-rrp-price')) {
  customElements.define('ed-rrp-price', EdRrpPrice);
}

/***/ }),

/***/ "./src/js/modules/ed-shipping-info.js":
/*!********************************************!*\
  !*** ./src/js/modules/ed-shipping-info.js ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _assets_events_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../assets/events.js */ "./assets/events.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var EdShippingInfo = /*#__PURE__*/function (_HTMLElement) {
  function EdShippingInfo() {
    var _this;
    _classCallCheck(this, EdShippingInfo);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, EdShippingInfo, [].concat(args));
    /**
     * Updates the shipping info.
     * @param {VariantUpdateEvent} event - The variant update event.
     */
    _defineProperty(_this, "updateShippingInfo", function (event) {
      if (event.detail.data.newProduct) {
        _this.dataset.productId = event.detail.data.newProduct.id;
      } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== _this.dataset.productId) {
        return;
      }
      var newShippingInfo = event.detail.data.html.querySelector('ed-shipping-info');
      if (!newShippingInfo) return;
      _this.innerHTML = newShippingInfo.innerHTML;
      _this.dataset.status = newShippingInfo.dataset.status;
    });
    return _this;
  }
  _inherits(EdShippingInfo, _HTMLElement);
  return _createClass(EdShippingInfo, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var closestSection = this.closest('.shopify-section, dialog');
      closestSection === null || closestSection === void 0 || closestSection.addEventListener(_assets_events_js__WEBPACK_IMPORTED_MODULE_0__.ThemeEvents.variantUpdate, this.updateShippingInfo);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var closestSection = this.closest('.shopify-section, dialog');
      closestSection === null || closestSection === void 0 || closestSection.removeEventListener(_assets_events_js__WEBPACK_IMPORTED_MODULE_0__.ThemeEvents.variantUpdate, this.updateShippingInfo);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-shipping-info')) {
  customElements.define('ed-shipping-info', EdShippingInfo);
}

/***/ }),

/***/ "./src/js/modules/ed-variant-auto-select.js":
/*!**************************************************!*\
  !*** ./src/js/modules/ed-variant-auto-select.js ***!
  \**************************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
/**
 * ELBDEV / customer based variant restrictions
 *
 * Rendered right after a variant picker whose option values were partly hidden for the current
 * customer (see snippets/variant-main-picker.liquid). When the pre-selected variant is one of the
 * hidden ones, no option is checked and the buy button would still add the hidden variant.
 * This element selects the first visible option instead, which triggers the regular variant update.
 * Works on the product page as well as for pickers injected later, e.g. in the quick-add modal.
 */
var EdVariantAutoSelect = /*#__PURE__*/function (_HTMLElement) {
  function EdVariantAutoSelect() {
    _classCallCheck(this, EdVariantAutoSelect);
    return _callSuper(this, EdVariantAutoSelect, arguments);
  }
  _inherits(EdVariantAutoSelect, _HTMLElement);
  return _createClass(EdVariantAutoSelect, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this = this;
      customElements.whenDefined('variant-picker').then(function () {
        _this._attachSelectors();
        _this._selectFirstVisibleOptions();
      });
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      var _this$parentElement;
      this.picker = (_this$parentElement = this.parentElement) === null || _this$parentElement === void 0 ? void 0 : _this$parentElement.querySelector("variant-picker[data-block-id=\"".concat(this.dataset.blockId, "\"]"));
    }
  }, {
    key: "_selectFirstVisibleOptions",
    value: function _selectFirstVisibleOptions() {
      if (!this.picker) return;
      this.picker.querySelectorAll('fieldset').forEach(function (fieldset) {
        var _fieldset$querySelect;
        if (fieldset.querySelector('input[type="radio"]:checked')) return;
        (_fieldset$querySelect = fieldset.querySelector('input[type="radio"]')) === null || _fieldset$querySelect === void 0 || _fieldset$querySelect.click();
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-variant-auto-select')) {
  customElements.define('ed-variant-auto-select', EdVariantAutoSelect);
}

/***/ }),

/***/ "./src/js/modules/ed-video-popup.js":
/*!******************************************!*\
  !*** ./src/js/modules/ed-video-popup.js ***!
  \******************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var EdVideoPopup = /*#__PURE__*/function () {
  function EdVideoPopup(trigger) {
    _classCallCheck(this, EdVideoPopup);
    this.trigger = trigger;
    var uid = trigger.dataset.edVideoTrigger;
    this.popup = document.querySelector("[data-ed-video-popup=\"".concat(uid, "\"]"));
    if (!this.popup) return;
    document.body.appendChild(this.popup);
    this.closeBtn = this.popup.querySelector('[data-ed-video-close]');
    this.backdrop = this.popup.querySelector('[data-ed-video-backdrop]');
    this.embedEl = this.popup.querySelector('[data-ed-video-embed]');
    this.nativeEl = this.popup.querySelector('[data-ed-video-native]');
    this.iframe = null;
    this.videoEl = null;
    this._onKeydown = this._handleKeydown.bind(this);
    this._bindEvents();
  }
  return _createClass(EdVideoPopup, [{
    key: "_bindEvents",
    value: function _bindEvents() {
      var _this = this,
        _this$closeBtn,
        _this$backdrop;
      this.trigger.addEventListener('click', function () {
        return _this.open();
      });
      (_this$closeBtn = this.closeBtn) === null || _this$closeBtn === void 0 || _this$closeBtn.addEventListener('click', function () {
        return _this.close();
      });
      (_this$backdrop = this.backdrop) === null || _this$backdrop === void 0 || _this$backdrop.addEventListener('click', function () {
        return _this.close();
      });
    }
  }, {
    key: "open",
    value: function open() {
      var _this2 = this;
      this._loadVideo();
      this.popup.removeAttribute('hidden');
      this.popup.setAttribute('aria-hidden', 'false');
      this.trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          return _this2.popup.classList.add('is-open');
        });
      });
      document.addEventListener('keydown', this._onKeydown);
      setTimeout(function () {
        var _this2$closeBtn;
        return (_this2$closeBtn = _this2.closeBtn) === null || _this2$closeBtn === void 0 ? void 0 : _this2$closeBtn.focus();
      }, 50);
    }
  }, {
    key: "close",
    value: function close() {
      var _this3 = this;
      this.popup.classList.remove('is-open');
      this.popup.setAttribute('aria-hidden', 'true');
      this.trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this._onKeydown);
      this._stopVideo();
      var _onEnd = function onEnd() {
        _this3.popup.setAttribute('hidden', '');
        _this3.popup.removeEventListener('transitionend', _onEnd);
      };
      this.popup.addEventListener('transitionend', _onEnd);
      this.trigger.focus();
    }
  }, {
    key: "_loadVideo",
    value: function _loadVideo() {
      var _this4 = this,
        _this$nativeEl;
      if (this.embedEl && !this.iframe) {
        this.iframe = document.createElement('iframe');
        this.iframe.allow = 'autoplay; fullscreen; picture-in-picture';
        this.iframe.setAttribute('allowfullscreen', '');
        this.iframe.title = 'Video';
        this.embedEl.appendChild(this.iframe);
      }
      if (this.iframe) {
        this.iframe.src = this.embedEl.dataset.embedUrl;
      }
      if (this.nativeEl && !this.videoEl) {
        var sources = JSON.parse(this.nativeEl.dataset.videoSources || '[]');
        var doAutoplay = this.nativeEl.dataset.videoAutoplay === 'true';
        var doLoop = this.nativeEl.dataset.videoLoop === 'true';
        this.videoEl = document.createElement('video');
        this.videoEl.controls = true;
        this.videoEl.loop = doLoop;
        this.videoEl.setAttribute('playsinline', '');
        sources.forEach(function (_ref) {
          var url = _ref.url,
            type = _ref.type;
          var src = document.createElement('source');
          src.src = url;
          src.type = type;
          _this4.videoEl.appendChild(src);
        });
        this.nativeEl.appendChild(this.videoEl);
        if (doAutoplay) this.videoEl.play()["catch"](function () {});
      } else if (this.videoEl && ((_this$nativeEl = this.nativeEl) === null || _this$nativeEl === void 0 ? void 0 : _this$nativeEl.dataset.videoAutoplay) === 'true') {
        this.videoEl.play()["catch"](function () {});
      }
    }
  }, {
    key: "_stopVideo",
    value: function _stopVideo() {
      if (this.iframe) this.iframe.src = 'about:blank';
      if (this.videoEl) {
        this.videoEl.pause();
        this.videoEl.currentTime = 0;
      }
    }
  }, {
    key: "_handleKeydown",
    value: function _handleKeydown(e) {
      if (e.key === 'Escape') {
        this.close();
        return;
      }
      if (e.key === 'Tab') this._trapFocus(e);
    }
  }, {
    key: "_trapFocus",
    value: function _trapFocus(e) {
      var focusable = _toConsumableArray(this.popup.querySelectorAll('button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'));
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable.at(-1);
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }]);
}();
document.querySelectorAll('[data-ed-video-trigger]').forEach(function (trigger) {
  return new EdVideoPopup(trigger);
});

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
var __webpack_exports__ = {};
/*!**************************!*\
  !*** ./src/js/custom.js ***!
  \**************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _modules_ed_rrp_price__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./modules/ed-rrp-price */ "./src/js/modules/ed-rrp-price.js");
/* harmony import */ var _modules_button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./modules/button */ "./src/js/modules/button.js");
/* harmony import */ var _modules_button__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_modules_button__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _modules_ed_shipping_info_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./modules/ed-shipping-info.js */ "./src/js/modules/ed-shipping-info.js");
/* harmony import */ var _modules_ed_pre_order_fields_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./modules/ed-pre-order-fields.js */ "./src/js/modules/ed-pre-order-fields.js");
/* harmony import */ var _modules_ed_variant_auto_select_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./modules/ed-variant-auto-select.js */ "./src/js/modules/ed-variant-auto-select.js");
/* harmony import */ var _modules_ed_variant_auto_select_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_variant_auto_select_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _modules_ed_forms_phone_sync_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./modules/ed-forms-phone-sync.js */ "./src/js/modules/ed-forms-phone-sync.js");
/* harmony import */ var _modules_ed_forms_phone_sync_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_forms_phone_sync_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _modules_ed_cart_share_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./modules/ed-cart-share.js */ "./src/js/modules/ed-cart-share.js");
/* harmony import */ var _modules_ed_cart_share_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_cart_share_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _modules_ed_gift_system__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./modules/ed-gift-system */ "./src/js/modules/ed-gift-system.js");
/* harmony import */ var _modules_ed_gift_system_drawer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./modules/ed-gift-system-drawer */ "./src/js/modules/ed-gift-system-drawer.js");
/* harmony import */ var _modules_ed_gift_system_drawer__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_gift_system_drawer__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _modules_ed_article_number_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./modules/ed-article-number.js */ "./src/js/modules/ed-article-number.js");
/* harmony import */ var _modules_ed_clear_cart_button__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./modules/ed-clear-cart-button */ "./src/js/modules/ed-clear-cart-button.js");
/* harmony import */ var _modules_ed_clear_cart_button__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_clear_cart_button__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _modules_ed_video_popup__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./modules/ed-video-popup */ "./src/js/modules/ed-video-popup.js");
/* harmony import */ var _modules_ed_video_popup__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_video_popup__WEBPACK_IMPORTED_MODULE_11__);
/*
DO NOT TOUCH THIS FILE OUTSIDE OF /src DIRECTORY
this file gets compiled ./assets/custom.js - make sure to import every module here.
*/








/** CART **/






})();

// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
/*!******************************!*\
  !*** ./src/scss/custom.scss ***!
  \******************************/
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin

})();

/******/ })()
;